import { BillInquiryMci, BillInquiryMciResponse } from "../proto/BillInquiryMci_pb";
import { BillInquiryTelecom, BillInquiryTelecomResponse } from "../proto/BillInquiryTelecom_pb";
import { ChannelAddAdmin, ChannelAddAdminResponse } from "../proto/ChannelAddAdmin_pb";
import { ChannelAddMember, ChannelAddMemberResponse } from "../proto/ChannelAddMember_pb";
import { ChannelAddMessageReaction, ChannelAddMessageReactionResponse } from "../proto/ChannelAddMessageReaction_pb";
import { ChannelAddModerator, ChannelAddModeratorResponse } from "../proto/ChannelAddModerator_pb";
import { ChannelAvatarAdd, ChannelAvatarAddResponse } from "../proto/ChannelAvatarAdd_pb";
import { ChannelAvatarDelete, ChannelAvatarDeleteResponse } from "../proto/ChannelAvatarDelete_pb";
import { ChannelAvatarGetList, ChannelAvatarGetListResponse } from "../proto/ChannelAvatarGetList_pb";
import { ChannelCheckUsername, ChannelCheckUsernameResponse } from "../proto/ChannelCheckUsername_pb";
import { ChannelCreate, ChannelCreateResponse } from "../proto/ChannelCreate_pb";
import { ChannelDelete, ChannelDeleteResponse } from "../proto/ChannelDelete_pb";
import { ChannelDeleteMessage, ChannelDeleteMessageResponse } from "../proto/ChannelDeleteMessage_pb";
import { ChannelEdit, ChannelEditResponse } from "../proto/ChannelEdit_pb";
import { ChannelEditMessage, ChannelEditMessageResponse } from "../proto/ChannelEditMessage_pb";
import { ChannelGetDraft, ChannelGetDraftResponse } from "../proto/ChannelGetDraft_pb";
import { ChannelGetMemberList, ChannelGetMemberListResponse } from "../proto/ChannelGetMemberList_pb";
import { ChannelGetMessagesStats, ChannelGetMessagesStatsResponse } from "../proto/ChannelGetMessagesStats_pb";
import { ChannelKickAdmin, ChannelKickAdminResponse } from "../proto/ChannelKickAdmin_pb";
import { ChannelKickMember, ChannelKickMemberResponse } from "../proto/ChannelKickMember_pb";
import { ChannelKickModerator, ChannelKickModeratorResponse } from "../proto/ChannelKickModerator_pb";
import { ChannelLeft, ChannelLeftResponse } from "../proto/ChannelLeft_pb";
import { ChannelPinMessage, ChannelPinMessageResponse } from "../proto/ChannelPinMessage_pb";
import { ChannelRemoveUsername, ChannelRemoveUsernameResponse } from "../proto/ChannelRemoveUsername_pb";
import { ChannelRevokeLink, ChannelRevokeLinkResponse } from "../proto/ChannelRevokeLink_pb";
import { ChannelSendMessage, ChannelSendMessageResponse } from "../proto/ChannelSendMessage_pb";
import { ChannelUpdateDraft, ChannelUpdateDraftResponse } from "../proto/ChannelUpdateDraft_pb";
import { ChannelUpdateReactionStatus, ChannelUpdateReactionStatusResponse } from "../proto/ChannelUpdateReactionStatus_pb";
import { ChannelUpdateSignature, ChannelUpdateSignatureResponse } from "../proto/ChannelUpdateSignature_pb";
import { ChannelUpdateUsername, ChannelUpdateUsernameResponse } from "../proto/ChannelUpdateUsername_pb";
import { ChatClearMessage, ChatClearMessageResponse } from "../proto/ChatClearMessage_pb";
import { ChatConvertToGroup, ChatConvertToGroupResponse } from "../proto/ChatConvertToGroup_pb";
import { ChatDelete, ChatDeleteResponse } from "../proto/ChatDelete_pb";
import { ChatDeleteMessage, ChatDeleteMessageResponse } from "../proto/ChatDeleteMessage_pb";
import { ChatEditMessage, ChatEditMessageResponse } from "../proto/ChatEditMessage_pb";
import { ChatGetDraft, ChatGetDraftResponse } from "../proto/ChatGetDraft_pb";
import { ChatGetRoom, ChatGetRoomResponse } from "../proto/ChatGetRoom_pb";
import { ChatSendMessage, ChatSendMessageResponse } from "../proto/ChatSendMessage_pb";
import { ChatSetAction, ChatSetActionResponse } from "../proto/ChatSetAction_pb";
import { ChatUpdateDraft, ChatUpdateDraftResponse } from "../proto/ChatUpdateDraft_pb";
import { ChatUpdateStatus, ChatUpdateStatusResponse } from "../proto/ChatUpdateStatus_pb";
import { ClientCheckInviteLink, ClientCheckInviteLinkResponse } from "../proto/ClientCheckInviteLink_pb";
import { ClientCondition, ClientConditionResponse } from "../proto/ClientCondition_pb";
import { ClientCountRoomHistory, ClientCountRoomHistoryResponse } from "../proto/ClientCountRoomHistory_pb";
import { ClientGetDiscovery, ClientGetDiscoveryResponse } from "../proto/ClientGetDiscovery_pb";
import { ClientGetFavoriteMenu, ClientGetFavoriteMenuResponse } from "../proto/ClientGetFavoriteMenu_pb";
import { ClientGetPoll, ClientGetPollResponse } from "../proto/ClientGetPoll_pb";
import { ClientGetPromote, ClientGetPromoteResponse } from "../proto/ClientGetPromote_pb";
import { ClientGetRoom, ClientGetRoomResponse } from "../proto/ClientGetRoom_pb";
import { ClientGetRoomHistory, ClientGetRoomHistoryResponse } from "../proto/ClientGetRoomHistory_pb";
import { ClientGetRoomList, ClientGetRoomListResponse } from "../proto/ClientGetRoomList_pb";
import { ClientGetRoomMessage, ClientGetRoomMessageResponse } from "../proto/ClientGetRoomMessage_pb";
import { ClientJoinByInviteLink, ClientJoinByInviteLinkResponse } from "../proto/ClientJoinByInviteLink_pb";
import { ClientJoinByUsername, ClientJoinByUsernameResponse } from "../proto/ClientJoinByUsername_pb";
import { ClientMuteRoom, ClientMuteRoomResponse } from "../proto/ClientMuteRoom_pb";
import { ClientPinRoom, ClientPinRoomResponse } from "../proto/ClientPinRoom_pb";
import { ClientRegisterDevice, ClientRegisterDeviceResponse } from "../proto/ClientRegisterDevice_pb";
import { ClientResolveUsername, ClientResolveUsernameResponse } from "../proto/ClientResolveUsername_pb";
import { ClientRoomReport, ClientRoomReportResponse } from "../proto/ClientRoomReport_pb";
import { ClientSearchRoomHistory, ClientSearchRoomHistoryResponse } from "../proto/ClientSearchRoomHistory_pb";
import { ClientSearchUsername, ClientSearchUsernameResponse } from "../proto/ClientSearchUsername_pb";
import { ClientSetDiscoveryItemAgreement, ClientSetDiscoveryItemAgreementResponse } from "../proto/ClientSetDiscoveryItemAgreement_pb";
import { ClientSetDiscoveryItemClick, ClientSetDiscoveryItemClickResponse } from "../proto/ClientSetDiscoveryItemClick_pb";
import { ClientSetPollItemClick, ClientSetPollItemClickResponse } from "../proto/ClientSetPollItemClick_pb";
import { ClientSubscribeToRoom, ClientSubscribeToRoomResponse } from "../proto/ClientSubscribeToRoom_pb";
import { ClientUnsubscribeFromRoom, ClientUnsubscribeFromRoomResponse } from "../proto/ClientUnsubscribeFromRoom_pb";
import { ConnectionSecuringResponse, ConnectionSymmetricKey, ConnectionSymmetricKeyResponse } from "../proto/ConnectionSecuring_pb";
import { ErrorResponse } from "../proto/Error_pb";
import { FileDownload, FileDownloadResponse } from "../proto/FileDownload_pb";
import { FileInfo, FileInfoResponse } from "../proto/FileInfo_pb";
import { FileUpload, FileUploadResponse } from "../proto/FileUpload_pb";
import { FileUploadInit, FileUploadInitResponse } from "../proto/FileUploadInit_pb";
import { FileUploadOption, FileUploadOptionResponse } from "../proto/FileUploadOption_pb";
import { FileUploadStatus, FileUploadStatusResponse } from "../proto/FileUploadStatus_pb";
import { GeoGetComment, GeoGetCommentResponse } from "../proto/GeoGetComment_pb";
import { GeoGetConfiguration, GeoGetConfigurationResponse } from "../proto/GeoGetConfiguration_pb";
import { GeoGetNearbyCoordinate, GeoGetNearbyCoordinateResponse } from "../proto/GeoGetNearbyCoordinate_pb";
import { GeoGetNearbyDistance, GeoGetNearbyDistanceResponse } from "../proto/GeoGetNearbyDistance_pb";
import { GeoGetRegisterStatus, GeoGetRegisterStatusResponse } from "../proto/GeoGetRegisterStatus_pb";
import { GeoRegister, GeoRegisterResponse } from "../proto/GeoRegister_pb";
import { GeoUpdateComment, GeoUpdateCommentResponse } from "../proto/GeoUpdateComment_pb";
import { GeoUpdatePosition, GeoUpdatePositionResponse } from "../proto/GeoUpdatePosition_pb";
import { GroupAddAdmin, GroupAddAdminResponse } from "../proto/GroupAddAdmin_pb";
import { GroupAddMember, GroupAddMemberResponse } from "../proto/GroupAddMember_pb";
import { GroupAddModerator, GroupAddModeratorResponse } from "../proto/GroupAddModerator_pb";
import { GroupAvatarAdd, GroupAvatarAddResponse } from "../proto/GroupAvatarAdd_pb";
import { GroupAvatarDelete, GroupAvatarDeleteResponse } from "../proto/GroupAvatarDelete_pb";
import { GroupAvatarGetList, GroupAvatarGetListResponse } from "../proto/GroupAvatarGetList_pb";
import { GroupChangeMemberRights, GroupChangeMemberRightsResponse } from "../proto/GroupChangeMemberRights_pb";
import { GroupCheckUsername, GroupCheckUsernameResponse } from "../proto/GroupCheckUsername_pb";
import { GroupClearMessage, GroupClearMessageResponse } from "../proto/GroupClearMessage_pb";
import { GroupCreate, GroupCreateResponse } from "../proto/GroupCreate_pb";
import { GroupDelete, GroupDeleteResponse } from "../proto/GroupDelete_pb";
import { GroupDeleteMessage, GroupDeleteMessageResponse } from "../proto/GroupDeleteMessage_pb";
import { GroupEdit, GroupEditResponse } from "../proto/GroupEdit_pb";
import { GroupEditMessage, GroupEditMessageResponse } from "../proto/GroupEditMessage_pb";
import { GroupGetDraft, GroupGetDraftResponse } from "../proto/GroupGetDraft_pb";
import { GroupGetMemberList, GroupGetMemberListResponse } from "../proto/GroupGetMemberList_pb";
import { GroupKickAdmin, GroupKickAdminResponse } from "../proto/GroupKickAdmin_pb";
import { GroupKickMember, GroupKickMemberResponse } from "../proto/GroupKickMember_pb";
import { GroupKickModerator, GroupKickModeratorResponse } from "../proto/GroupKickModerator_pb";
import { GroupLeft, GroupLeftResponse } from "../proto/GroupLeft_pb";
import { GroupPinMessage, GroupPinMessageResponse } from "../proto/GroupPinMessage_pb";
import { GroupRemoveUsername, GroupRemoveUsernameResponse } from "../proto/GroupRemoveUsername_pb";
import { GroupRevokeLink, GroupRevokeLinkResponse } from "../proto/GroupRevokeLink_pb";
import { GroupSendMessage, GroupSendMessageResponse } from "../proto/GroupSendMessage_pb";
import { GroupSetAction, GroupSetActionResponse } from "../proto/GroupSetAction_pb";
import { GroupUpdateDraft, GroupUpdateDraftResponse } from "../proto/GroupUpdateDraft_pb";
import { GroupUpdateStatus, GroupUpdateStatusResponse } from "../proto/GroupUpdateStatus_pb";
import { GroupUpdateUsername, GroupUpdateUsernameResponse } from "../proto/GroupUpdateUsername_pb";
import { Heartbeat, HeartbeatResponse } from "../proto/Heartbeat_pb";
import { InfoConfig, InfoConfigResponse } from "../proto/InfoConfig_pb";
import { InfoCountry, InfoCountryResponse } from "../proto/InfoCountry_pb";
import { InfoLocation, InfoLocationResponse } from "../proto/InfoLocation_pb";
import { InfoPage, InfoPageResponse } from "../proto/InfoPage_pb";
import { InfoTime, InfoTimeResponse } from "../proto/InfoTime_pb";
import { InfoWallpaper, InfoWallpaperResponse } from "../proto/InfoWallpaper_pb";
import { MplGetBillToken, MplGetBillTokenResponse } from "../proto/MplGetBillToken_pb";
import { MplGetSalesToken, MplGetSalesTokenResponse } from "../proto/MplGetSalesToken_pb";
import { MplGetTopupToken, MplGetTopupTokenResponse } from "../proto/MplGetTopupToken_pb";
import { PushLoginTokenResponse } from "../proto/PushLoginToken_pb";
import { PushRateSignalingResponse } from "../proto/PushRateSignaling_pb";
import { PushTwoStepVerificationResponse } from "../proto/PushTwoStepVerification_pb";
import { PushUserInfoExpiredResponse } from "../proto/PushUserInfoExpired_pb";
import { PushWalletPaymentVerifiedResponse } from "../proto/PushWalletPaymentVerified_pb";
import { QrCodeAddContact, QrCodeAddContactResponse } from "../proto/QrCodeAddContact_pb";
import { QrCodeAddMe, QrCodeAddMeResponse } from "../proto/QrCodeAddMe_pb";
import { QrCodeJoin, QrCodeJoinResponse } from "../proto/QrCodeJoin_pb";
import { QrCodeNewDevice, QrCodeNewDeviceResponse } from "../proto/QrCodeNewDevice_pb";
import { QrCodeResolve, QrCodeResolveResponse } from "../proto/QrCodeResolve_pb";
import { SignalingAccept, SignalingAcceptResponse } from "../proto/SignalingAccept_pb";
import { SignalingCandidate, SignalingCandidateResponse } from "../proto/SignalingCandidate_pb";
import { SignalingClearLog, SignalingClearLogResponse } from "../proto/SignalingClearLog_pb";
import { SignalingGetConfiguration, SignalingGetConfigurationResponse } from "../proto/SignalingGetConfiguration_pb";
import { SignalingGetLog, SignalingGetLogResponse } from "../proto/SignalingGetLog_pb";
import { SignalingLeave, SignalingLeaveResponse } from "../proto/SignalingLeave_pb";
import { SignalingOffer, SignalingOfferResponse } from "../proto/SignalingOffer_pb";
import { SignalingRate, SignalingRateResponse } from "../proto/SignalingRate_pb";
import { SignalingRinging, SignalingRingingResponse } from "../proto/SignalingRinging_pb";
import { SignalingSessionHold, SignalingSessionHoldResponse } from "../proto/SignalingSessionHold_pb";
import { UserAvatarAdd, UserAvatarAddResponse } from "../proto/UserAvatarAdd_pb";
import { UserAvatarDelete, UserAvatarDeleteResponse } from "../proto/UserAvatarDelete_pb";
import { UserAvatarGetList, UserAvatarGetListResponse } from "../proto/UserAvatarGetList_pb";
import { UserContactsBlock, UserContactsBlockResponse } from "../proto/UserContactsBlock_pb";
import { UserContactsDelete, UserContactsDeleteResponse } from "../proto/UserContactsDelete_pb";
import { UserContactsEdit, UserContactsEditResponse } from "../proto/UserContactsEdit_pb";
import { UserContactsGetBlockedList, UserContactsGetBlockedListResponse } from "../proto/UserContactsGetBlockedList_pb";
import { UserContactsGetList, UserContactsGetListResponse } from "../proto/UserContactsGetList_pb";
import { UserContactsImport, UserContactsImportResponse } from "../proto/UserContactsImport_pb";
import { UserContactsUnblock, UserContactsUnblockResponse } from "../proto/UserContactsUnblock_pb";
import { UserDelete, UserDeleteResponse } from "../proto/UserDelete_pb";
import { UserGetDeleteToken, UserGetDeleteTokenResponse } from "../proto/UserGetDeleteToken_pb";
import { UserInfo, UserInfoResponse } from "../proto/UserInfo_pb";
import { UserIVandGetActivities, UserIVandGetActivitiesResponse } from "../proto/UserIVandGetActivities_pb";
import { UserIVandGetScore, UserIVandGetScoreResponse } from "../proto/UserIVandGetScore_pb";
import { UserIVandSetActivity, UserIVandSetActivityResponse } from "../proto/UserIVandSetActivity_pb";
import { UserLogin, UserLoginResponse } from "../proto/UserLogin_pb";
import { UserPrivacyGetRule, UserPrivacyGetRuleResponse } from "../proto/UserPrivacyGetRule_pb";
import { UserPrivacySetRule, UserPrivacySetRuleResponse } from "../proto/UserPrivacySetRule_pb";
import { UserProfileCheckUsername, UserProfileCheckUsernameResponse } from "../proto/UserProfileCheckUsername_pb";
import { UserProfileGetBio, UserProfileGetBioResponse } from "../proto/UserProfileGetBio_pb";
import { UserProfileGetEmail, UserProfileGetEmailResponse } from "../proto/UserProfileGetEmail_pb";
import { UserProfileGetGender, UserProfileGetGenderResponse } from "../proto/UserProfileGetGender_pb";
import { UserProfileGetNickname, UserProfileGetNicknameResponse } from "../proto/UserProfileGetNickname_pb";
import { UserProfileGetRepresentative, UserProfileGetRepresentativeResponse } from "../proto/UserProfileGetRepresentative_pb";
import { UserProfileGetSelfRemove, UserProfileGetSelfRemoveResponse } from "../proto/UserProfileGetSelfRemove_pb";
import { UserProfileSetBio, UserProfileSetBioResponse } from "../proto/UserProfileSetBio_pb";
import { UserProfileSetEmail, UserProfileSetEmailResponse } from "../proto/UserProfileSetEmail_pb";
import { UserProfileSetGender, UserProfileSetGenderResponse } from "../proto/UserProfileSetGender_pb";
import { UserProfileSetNickname, UserProfileSetNicknameResponse } from "../proto/UserProfileSetNickname_pb";
import { UserProfileSetRepresentative, UserProfileSetRepresentativeResponse } from "../proto/UserProfileSetRepresentative_pb";
import { UserProfileSetSelfRemove, UserProfileSetSelfRemoveResponse } from "../proto/UserProfileSetSelfRemove_pb";
import { UserProfileUpdateUsername, UserProfileUpdateUsernameResponse } from "../proto/UserProfileUpdateUsername_pb";
import { UserRegister, UserRegisterResponse } from "../proto/UserRegister_pb";
import { UserReport, UserReportResponse } from "../proto/UserReport_pb";
import { UserSessionGetActiveList, UserSessionGetActiveListResponse } from "../proto/UserSessionGetActiveList_pb";
import { UserSessionLogout, UserSessionLogoutResponse } from "../proto/UserSessionLogout_pb";
import { UserSessionTerminate, UserSessionTerminateResponse } from "../proto/UserSessionTerminate_pb";
import { UserSetBot, UserSetBotResponse } from "../proto/UserSetBot_pb";
import { UserTwoStepVerificationChangeHint, UserTwoStepVerificationChangeHintResponse } from "../proto/UserTwoStepVerificationChangeHint_pb";
import { UserTwoStepVerificationChangeRecoveryEmail, UserTwoStepVerificationChangeRecoveryEmailResponse } from "../proto/UserTwoStepVerificationChangeRecoveryEmail_pb";
import { UserTwoStepVerificationChangeRecoveryQuestion, UserTwoStepVerificationChangeRecoveryQuestionResponse } from "../proto/UserTwoStepVerificationChangeRecoveryQuestion_pb";
import { UserTwoStepVerificationCheckPassword, UserTwoStepVerificationCheckPasswordResponse } from "../proto/UserTwoStepVerificationCheckPassword_pb";
import { UserTwoStepVerificationGetPasswordDetail, UserTwoStepVerificationGetPasswordDetailResponse } from "../proto/UserTwoStepVerificationGetPasswordDetail_pb";
import { UserTwoStepVerificationRecoverPasswordByAnswers, UserTwoStepVerificationRecoverPasswordByAnswersResponse } from "../proto/UserTwoStepVerificationRecoverPasswordByAnswers_pb";
import { UserTwoStepVerificationRecoverPasswordByToken, UserTwoStepVerificationRecoverPasswordByTokenResponse } from "../proto/UserTwoStepVerificationRecoverPasswordByToken_pb";
import { UserTwoStepVerificationRequestRecoveryToken, UserTwoStepVerificationRequestRecoveryTokenResponse } from "../proto/UserTwoStepVerificationRequestRecoveryToken_pb";
import { UserTwoStepVerificationResendVerifyEmail, UserTwoStepVerificationResendVerifyEmailResponse } from "../proto/UserTwoStepVerificationResendVerifyEmail_pb";
import { UserTwoStepVerificationSetPassword, UserTwoStepVerificationSetPasswordResponse } from "../proto/UserTwoStepVerificationSetPassword_pb";
import { UserTwoStepVerificationUnsetPassword, UserTwoStepVerificationUnsetPasswordResponse } from "../proto/UserTwoStepVerificationUnsetPassword_pb";
import { UserTwoStepVerificationVerifyPassword, UserTwoStepVerificationVerifyPasswordResponse } from "../proto/UserTwoStepVerificationVerifyPassword_pb";
import { UserTwoStepVerificationVerifyRecoveryEmail, UserTwoStepVerificationVerifyRecoveryEmailResponse } from "../proto/UserTwoStepVerificationVerifyRecoveryEmail_pb";
import { UserUpdateStatus, UserUpdateStatusResponse } from "../proto/UserUpdateStatus_pb";
import { UserUsernameToId, UserUsernameToIdResponse } from "../proto/UserUsernameToId_pb";
import { UserVerify, UserVerifyResponse } from "../proto/UserVerify_pb";
import { UserVerifyNewDevice, UserVerifyNewDeviceResponse } from "../proto/UserVerifyNewDevice_pb";
import { WalletGetAccessToken, WalletGetAccessTokenResponse } from "../proto/WalletGetAccessToken_pb";
import { WalletIdMapping, WalletIdMappingResponse } from "../proto/WalletIdMapping_pb";
import { WalletPaymentInit, WalletPaymentInitResponse } from "../proto/WalletPaymentInit_pb";
import { WalletRegister, WalletRegisterResponse } from "../proto/WalletRegister_pb";
import * as methods from "./methods";
import { MplTransactionList, MplTransactionListResponse } from "../proto/MplTransactionList_pb";
import { MplTransactionInfo, MplTransactionInfoResponse } from "../proto/MplTransactionInfo_pb";
import { InfoUpdate, InfoUpdateResponse } from "../proto/InfoUpdate_pb";
import { StoryGetStories, StoryGetStoriesResponse } from "../proto/StoryGetStories_pb";
import { StoryUserAddNew, StoryUserAddNewResponse } from "../proto/StoryUserAddNew_pb";
import { StoryAddView, StoryAddViewResponse } from "../proto/StoryAddView_pb";
import { StoryGetOwnStoryViews, StoryGetOwnStoryViewsResponse } from "../proto/StoryGetOwnStoryViews_pb";
import { StoryDeleteStory, StoryDeleteStoryResponse } from "../proto/StoryDeleteStory_pb";
import { ClientRoomChangeOwner, ClientRoomChangeOwnerResponse } from "../proto/ClientRoomChangeOwner_pb";
import { ChangePhoneNumber, ChangePhoneNumberResponse } from "../proto/ChangePhoneNumber_pb";
import { CLIENT_ROOM_CHANGE_OWNER_RESPONSE, CLIENT_ROOM_MEMBER_SEARCH, CLIENT_ROOM_MEMBER_SEARCH_RESPONSE, GROUP_ROOM_MEMBER_MENTION, USER_VERIFY_NEW_PHONE_NUMBER } from "./methods";
import { VerifyNewPhoneNumber, VerifyNewPhoneNumberResponse } from "../proto/VerifyNewPhoneNumber_pb";
import { ClientSearch, ClientSearchResponse } from "../proto/ClientSearch_pb";
import { ClientRoomMemberSearch, ClientRoomMemberSearchResponse } from "../proto/ClientRoomMemberSearch_pb";
import { GroupRoomMemberMention, GroupRoomMemberMentionResponse } from "../proto/GroupRoomMemberMention_pb";

export type MessageRequest =
  | BillInquiryMci
  | BillInquiryTelecom
  | ChannelAddAdmin
  | ChannelAddMember
  | ChannelAddMessageReaction
  | ChannelAddModerator
  | ChannelAvatarAdd
  | ChannelAvatarDelete
  | ChannelAvatarGetList
  | ChannelCheckUsername
  | ChannelCreate
  | ChannelDelete
  | ChannelDeleteMessage
  | ChannelEdit
  | ChannelEditMessage
  | ChannelGetDraft
  | ChannelGetMemberList
  | ChannelGetMessagesStats
  | ChannelKickAdmin
  | ChannelKickMember
  | ChannelKickModerator
  | ChannelLeft
  | ChannelPinMessage
  | ChannelRemoveUsername
  | ChannelRevokeLink
  | ChannelSendMessage
  | ChannelUpdateDraft
  | ChannelUpdateReactionStatus
  | ChannelUpdateSignature
  | ChannelUpdateUsername
  | ChatClearMessage
  | ChatConvertToGroup
  | ChatDelete
  | ChatDeleteMessage
  | ChatEditMessage
  | ChatGetDraft
  | ChatGetRoom
  | ChatSendMessage
  | ChatSetAction
  | ChatUpdateDraft
  | ChatUpdateStatus
  | ClientCheckInviteLink
  | ClientCondition
  | ClientCountRoomHistory
  | ClientGetDiscovery
  | ClientGetFavoriteMenu
  | ClientGetPoll
  | ClientGetPromote
  | ClientGetRoom
  | ClientGetRoomHistory
  | ClientGetRoomList
  | ClientGetRoomMessage
  | ClientJoinByInviteLink
  | ClientJoinByUsername
  | ClientMuteRoom
  | ClientPinRoom
  | ClientRegisterDevice
  | ClientResolveUsername
  | ClientRoomReport
  | ClientSearchRoomHistory
  | ClientSearchUsername
  | ClientSetDiscoveryItemAgreement
  | ClientSetDiscoveryItemClick
  | ClientSetPollItemClick
  | ClientSubscribeToRoom
  | ClientUnsubscribeFromRoom
  | ConnectionSymmetricKey
  | FileDownload
  | FileInfo
  | FileUpload
  | FileUploadInit
  | FileUploadOption
  | FileUploadStatus
  | GeoGetComment
  | GeoGetConfiguration
  | GeoGetNearbyCoordinate
  | GeoGetNearbyDistance
  | GeoGetRegisterStatus
  | GeoRegister
  | GeoUpdateComment
  | GeoUpdatePosition
  | GroupAddAdmin
  | GroupAddMember
  | GroupAddModerator
  | GroupAvatarAdd
  | GroupAvatarDelete
  | GroupAvatarGetList
  | GroupChangeMemberRights
  | GroupCheckUsername
  | GroupClearMessage
  | GroupCreate
  | GroupDelete
  | GroupDeleteMessage
  | GroupEdit
  | GroupEditMessage
  | GroupGetDraft
  | GroupGetMemberList
  | GroupKickAdmin
  | GroupKickMember
  | GroupKickModerator
  | GroupLeft
  | GroupPinMessage
  | GroupRemoveUsername
  | GroupRevokeLink
  | GroupSendMessage
  | GroupSetAction
  | GroupUpdateDraft
  | GroupUpdateStatus
  | GroupUpdateUsername
  | Heartbeat
  | InfoConfig
  | InfoCountry
  | InfoLocation
  | InfoPage
  | InfoTime
  | InfoWallpaper
  | MplGetBillToken
  | MplGetSalesToken
  | MplGetTopupToken
  | MplTransactionList
  | QrCodeAddContact
  | QrCodeAddMe
  | QrCodeJoin
  | QrCodeNewDevice
  | QrCodeResolve
  | SignalingAccept
  | SignalingCandidate
  | SignalingClearLog
  | SignalingGetConfiguration
  | SignalingGetLog
  | SignalingLeave
  | SignalingOffer
  | SignalingRate
  | SignalingRinging
  | SignalingSessionHold
  | UserAvatarAdd
  | UserAvatarDelete
  | UserAvatarGetList
  | UserContactsBlock
  | UserContactsDelete
  | UserContactsEdit
  | UserContactsGetBlockedList
  | UserContactsGetList
  | UserContactsImport
  | UserContactsUnblock
  | UserDelete
  | UserGetDeleteToken
  | UserIVandGetActivities
  | UserIVandGetScore
  | UserIVandSetActivity
  | UserInfo
  | UserLogin
  | UserPrivacyGetRule
  | UserPrivacySetRule
  | UserProfileCheckUsername
  | UserProfileGetBio
  | UserProfileGetEmail
  | UserProfileGetGender
  | UserProfileGetNickname
  | UserProfileGetRepresentative
  | UserProfileGetSelfRemove
  | UserProfileSetBio
  | UserProfileSetEmail
  | UserProfileSetGender
  | UserProfileSetNickname
  | UserProfileSetRepresentative
  | UserProfileSetSelfRemove
  | UserProfileUpdateUsername
  | UserRegister
  | UserReport
  | UserSessionGetActiveList
  | UserSessionLogout
  | UserSessionTerminate
  | UserSetBot
  | UserTwoStepVerificationChangeHint
  | UserTwoStepVerificationChangeRecoveryEmail
  | UserTwoStepVerificationChangeRecoveryQuestion
  | UserTwoStepVerificationCheckPassword
  | UserTwoStepVerificationGetPasswordDetail
  | UserTwoStepVerificationRecoverPasswordByAnswers
  | UserTwoStepVerificationRecoverPasswordByToken
  | UserTwoStepVerificationRequestRecoveryToken
  | UserTwoStepVerificationResendVerifyEmail
  | UserTwoStepVerificationSetPassword
  | UserTwoStepVerificationUnsetPassword
  | UserTwoStepVerificationVerifyPassword
  | UserTwoStepVerificationVerifyRecoveryEmail
  | UserUpdateStatus
  | UserUsernameToId
  | UserVerify
  | UserVerifyNewDevice
  | WalletGetAccessToken
  | WalletIdMapping
  | WalletPaymentInit
  | WalletRegister
  | StoryGetStories
  | StoryAddView
  | StoryGetOwnStoryViews
  | StoryDeleteStory
  | ClientSearch;

export type MessageResponse =
  | BillInquiryMciResponse
  | BillInquiryTelecomResponse
  | ChannelAddAdminResponse
  | ChannelAddMemberResponse
  | ChannelAddMessageReactionResponse
  | ChannelAddModeratorResponse
  | ChannelAvatarAddResponse
  | ChannelAvatarDeleteResponse
  | ChannelAvatarGetListResponse
  | ChannelCheckUsernameResponse
  | ChannelCreateResponse
  | ChannelDeleteMessageResponse
  | ChannelDeleteResponse
  | ChannelEditMessageResponse
  | ChannelEditResponse
  | ChannelGetDraftResponse
  | ChannelGetMemberListResponse
  | ChannelGetMessagesStatsResponse
  | ChannelKickAdminResponse
  | ChannelKickMemberResponse
  | ChannelKickModeratorResponse
  | ChannelLeftResponse
  | ChannelPinMessageResponse
  | ChannelRemoveUsernameResponse
  | ChannelRevokeLinkResponse
  | ChannelSendMessageResponse
  | ChannelUpdateDraftResponse
  | ChannelUpdateReactionStatusResponse
  | ChannelUpdateSignatureResponse
  | ChannelUpdateUsernameResponse
  | ChatClearMessageResponse
  | ChatConvertToGroupResponse
  | ChatDeleteMessageResponse
  | ChatDeleteResponse
  | ChatEditMessageResponse
  | ChatGetDraftResponse
  | ChatGetRoomResponse
  | ChatSendMessageResponse
  | ChatSetActionResponse
  | ChatUpdateDraftResponse
  | ChatUpdateStatusResponse
  | ClientCheckInviteLinkResponse
  | ClientConditionResponse
  | ClientCountRoomHistoryResponse
  | ClientGetDiscoveryResponse
  | ClientGetFavoriteMenuResponse
  | ClientGetPollResponse
  | ClientGetPromoteResponse
  | ClientGetRoomHistoryResponse
  | ClientGetRoomListResponse
  | ClientGetRoomMessageResponse
  | ClientGetRoomResponse
  | ClientJoinByInviteLinkResponse
  | ClientJoinByUsernameResponse
  | ClientMuteRoomResponse
  | ClientPinRoomResponse
  | ClientRegisterDeviceResponse
  | ClientResolveUsernameResponse
  | ClientRoomReportResponse
  | ClientSearchRoomHistoryResponse
  | ClientSearchUsernameResponse
  | ClientSetDiscoveryItemAgreementResponse
  | ClientSetDiscoveryItemClickResponse
  | ClientSetPollItemClickResponse
  | ClientSubscribeToRoomResponse
  | ClientUnsubscribeFromRoomResponse
  | FileDownloadResponse
  | FileInfoResponse
  | FileUploadInitResponse
  | FileUploadOptionResponse
  | FileUploadResponse
  | FileUploadStatusResponse
  | GeoGetCommentResponse
  | GeoGetConfigurationResponse
  | GeoGetNearbyCoordinateResponse
  | GeoGetNearbyDistanceResponse
  | GeoGetRegisterStatusResponse
  | GeoRegisterResponse
  | GeoUpdateCommentResponse
  | GeoUpdatePositionResponse
  | GroupAddAdminResponse
  | GroupAddMemberResponse
  | GroupAddModeratorResponse
  | GroupAvatarAddResponse
  | GroupAvatarDeleteResponse
  | GroupAvatarGetListResponse
  | GroupChangeMemberRightsResponse
  | GroupCheckUsernameResponse
  | GroupClearMessageResponse
  | GroupCreateResponse
  | GroupDeleteMessageResponse
  | GroupDeleteResponse
  | GroupEditMessageResponse
  | GroupEditResponse
  | GroupGetDraftResponse
  | GroupGetMemberListResponse
  | GroupKickAdminResponse
  | GroupKickMemberResponse
  | GroupKickModeratorResponse
  | GroupLeftResponse
  | GroupPinMessageResponse
  | GroupRemoveUsernameResponse
  | GroupRevokeLinkResponse
  | GroupSendMessageResponse
  | GroupSetActionResponse
  | GroupUpdateDraftResponse
  | GroupUpdateStatusResponse
  | GroupUpdateUsernameResponse
  | HeartbeatResponse
  | InfoConfigResponse
  | InfoCountryResponse
  | InfoLocationResponse
  | InfoPageResponse
  | InfoTimeResponse
  | InfoWallpaperResponse
  | MplGetBillTokenResponse
  | MplGetSalesTokenResponse
  | MplGetTopupTokenResponse
  | MplTransactionListResponse
  | PushLoginTokenResponse
  | PushRateSignalingResponse
  | PushTwoStepVerificationResponse
  | PushUserInfoExpiredResponse
  | PushWalletPaymentVerifiedResponse
  | QrCodeAddContactResponse
  | QrCodeAddMeResponse
  | QrCodeJoinResponse
  | QrCodeNewDeviceResponse
  | QrCodeResolveResponse
  | SignalingAcceptResponse
  | SignalingCandidateResponse
  | SignalingClearLogResponse
  | SignalingGetConfigurationResponse
  | SignalingGetLogResponse
  | SignalingLeaveResponse
  | SignalingOfferResponse
  | SignalingRateResponse
  | SignalingRingingResponse
  | SignalingSessionHoldResponse
  | UserAvatarAddResponse
  | UserAvatarDeleteResponse
  | UserAvatarGetListResponse
  | UserContactsBlockResponse
  | UserContactsDeleteResponse
  | UserContactsEditResponse
  | UserContactsGetBlockedListResponse
  | UserContactsGetListResponse
  | UserContactsImportResponse
  | UserContactsUnblockResponse
  | UserDeleteResponse
  | UserGetDeleteTokenResponse
  | UserIVandGetActivitiesResponse
  | UserIVandGetScoreResponse
  | UserIVandSetActivityResponse
  | UserInfoResponse
  | UserLoginResponse
  | UserPrivacyGetRuleResponse
  | UserPrivacySetRuleResponse
  | UserProfileCheckUsernameResponse
  | UserProfileGetBioResponse
  | UserProfileGetEmailResponse
  | UserProfileGetGenderResponse
  | UserProfileGetNicknameResponse
  | UserProfileGetRepresentativeResponse
  | UserProfileGetSelfRemoveResponse
  | UserProfileSetBioResponse
  | UserProfileSetEmailResponse
  | UserProfileSetGenderResponse
  | UserProfileSetNicknameResponse
  | UserProfileSetRepresentativeResponse
  | UserProfileSetSelfRemoveResponse
  | UserProfileUpdateUsernameResponse
  | UserRegisterResponse
  | UserReportResponse
  | UserSessionGetActiveListResponse
  | UserSessionLogoutResponse
  | UserSessionTerminateResponse
  | UserSetBotResponse
  | UserTwoStepVerificationChangeHintResponse
  | UserTwoStepVerificationChangeRecoveryEmailResponse
  | UserTwoStepVerificationChangeRecoveryQuestionResponse
  | UserTwoStepVerificationCheckPasswordResponse
  | UserTwoStepVerificationGetPasswordDetailResponse
  | UserTwoStepVerificationRecoverPasswordByAnswersResponse
  | UserTwoStepVerificationRecoverPasswordByTokenResponse
  | UserTwoStepVerificationRequestRecoveryTokenResponse
  | UserTwoStepVerificationResendVerifyEmailResponse
  | UserTwoStepVerificationSetPasswordResponse
  | UserTwoStepVerificationUnsetPasswordResponse
  | UserTwoStepVerificationVerifyPasswordResponse
  | UserTwoStepVerificationVerifyRecoveryEmailResponse
  | UserUpdateStatusResponse
  | UserUsernameToIdResponse
  | UserVerifyNewDeviceResponse
  | UserVerifyResponse
  | WalletGetAccessTokenResponse
  | WalletIdMappingResponse
  | WalletPaymentInitResponse
  | WalletRegisterResponse
  | StoryGetStoriesResponse
  | StoryAddViewResponse
  | StoryGetOwnStoryViewsResponse
  | StoryDeleteStoryResponse
  | ClientSearchResponse;

export const protoRequestsTable = {
  [methods.BILL_INQUIRY_MCI]: BillInquiryMci,
  [methods.BILL_INQUIRY_TELECOM]: BillInquiryTelecom,
  [methods.CHANNEL_ADD_ADMIN]: ChannelAddAdmin,
  [methods.CHANNEL_ADD_MEMBER]: ChannelAddMember,
  [methods.CHANNEL_ADD_MESSAGE_REACTION]: ChannelAddMessageReaction,
  [methods.CHANNEL_ADD_MODERATOR]: ChannelAddModerator,
  [methods.CHANNEL_AVATAR_ADD]: ChannelAvatarAdd,
  [methods.CHANNEL_AVATAR_DELETE]: ChannelAvatarDelete,
  [methods.CHANNEL_AVATAR_GET_LIST]: ChannelAvatarGetList,
  [methods.CHANNEL_CHECK_USERNAME]: ChannelCheckUsername,
  [methods.CHANNEL_CREATE]: ChannelCreate,
  [methods.CHANNEL_DELETE]: ChannelDelete,
  [methods.CHANNEL_DELETE_MESSAGE]: ChannelDeleteMessage,
  [methods.CHANNEL_EDIT]: ChannelEdit,
  [methods.CHANNEL_EDIT_MESSAGE]: ChannelEditMessage,
  [methods.CHANNEL_GET_DRAFT]: ChannelGetDraft,
  [methods.CHANNEL_GET_MEMBER_LIST]: ChannelGetMemberList,
  [methods.CHANNEL_GET_MESSAGES_STATS]: ChannelGetMessagesStats,
  [methods.CHANNEL_KICK_ADMIN]: ChannelKickAdmin,
  [methods.CHANNEL_KICK_MEMBER]: ChannelKickMember,
  [methods.CHANNEL_KICK_MODERATOR]: ChannelKickModerator,
  [methods.CHANNEL_LEFT]: ChannelLeft,
  [methods.CHANNEL_PIN_MESSAGE]: ChannelPinMessage,
  [methods.CHANNEL_REMOVE_USERNAME]: ChannelRemoveUsername,
  [methods.CHANNEL_REVOKE_LINK]: ChannelRevokeLink,
  [methods.CHANNEL_SEND_MESSAGE]: ChannelSendMessage,
  [methods.CHANNEL_UPDATE_DRAFT]: ChannelUpdateDraft,
  [methods.CHANNEL_UPDATE_REACTION_STATUS]: ChannelUpdateReactionStatus,
  [methods.CHANNEL_UPDATE_SIGNATURE]: ChannelUpdateSignature,
  [methods.CHANNEL_UPDATE_USERNAME]: ChannelUpdateUsername,
  [methods.CHAT_CLEAR_MESSAGE]: ChatClearMessage,
  [methods.CHAT_CONVERT_TO_GROUP]: ChatConvertToGroup,
  [methods.CHAT_DELETE]: ChatDelete,
  [methods.CHAT_DELETE_MESSAGE]: ChatDeleteMessage,
  [methods.CHAT_EDIT_MESSAGE]: ChatEditMessage,
  [methods.CHAT_GET_DRAFT]: ChatGetDraft,
  [methods.CHAT_GET_ROOM]: ChatGetRoom,
  [methods.CHAT_SEND_MESSAGE]: ChatSendMessage,
  [methods.CHAT_SET_ACTION]: ChatSetAction,
  [methods.CHAT_UPDATE_DRAFT]: ChatUpdateDraft,
  [methods.CHAT_UPDATE_STATUS]: ChatUpdateStatus,
  [methods.CLIENT_CHECK_INVITE_LINK]: ClientCheckInviteLink,
  [methods.CLIENT_CONDITION]: ClientCondition,
  [methods.CLIENT_COUNT_ROOM_HISTORY]: ClientCountRoomHistory,
  [methods.CLIENT_GET_DISCOVERY]: ClientGetDiscovery,
  [methods.CLIENT_GET_FAVORITE_MENU]: ClientGetFavoriteMenu,
  [methods.CLIENT_GET_POLL]: ClientGetPoll,
  [methods.CLIENT_GET_PROMOTE]: ClientGetPromote,
  [methods.CLIENT_GET_ROOM]: ClientGetRoom,
  [methods.CLIENT_GET_ROOM_HISTORY]: ClientGetRoomHistory,
  [methods.CLIENT_GET_ROOM_LIST]: ClientGetRoomList,
  [methods.CLIENT_GET_ROOM_MESSAGE]: ClientGetRoomMessage,
  [methods.CLIENT_JOIN_BY_INVITE_LINK]: ClientJoinByInviteLink,
  [methods.CLIENT_JOIN_BY_USERNAME]: ClientJoinByUsername,
  [methods.CLIENT_MUTE_ROOM]: ClientMuteRoom,
  [methods.CLIENT_PIN_ROOM]: ClientPinRoom,
  [methods.CLIENT_REGISTER_DEVICE]: ClientRegisterDevice,
  [methods.CLIENT_RESOLVE_USERNAME]: ClientResolveUsername,
  [methods.CLIENT_ROOM_REPORT]: ClientRoomReport,
  [methods.CLIENT_SEARCH_ROOM_HISTORY]: ClientSearchRoomHistory,
  [methods.CLIENT_SEARCH_USERNAME]: ClientSearchUsername,
  [methods.CLIENT_SET_DISCOVERY_ITEM_AGREEMENT]: ClientSetDiscoveryItemAgreement,
  [methods.CLIENT_SET_DISCOVERY_ITEM_CLICK]: ClientSetDiscoveryItemClick,
  [methods.CLIENT_SET_POLL_ITEM_CLICK]: ClientSetPollItemClick,
  [methods.CLIENT_SUBSCRIBE_TO_ROOM]: ClientSubscribeToRoom,
  [methods.CLIENT_UNSUBSCRIBE_FROM_ROOM]: ClientUnsubscribeFromRoom,
  [methods.CONNECTION_SYMMETRIC_KEY]: ConnectionSymmetricKey,
  [methods.FILE_DOWNLOAD]: FileDownload,
  [methods.FILE_INFO]: FileInfo,
  [methods.FILE_UPLOAD]: FileUpload,
  [methods.FILE_UPLOAD_INIT]: FileUploadInit,
  [methods.FILE_UPLOAD_OPTION]: FileUploadOption,
  [methods.FILE_UPLOAD_STATUS]: FileUploadStatus,
  [methods.GEO_GET_COMMENT]: GeoGetComment,
  [methods.GEO_GET_CONFIGURATION]: GeoGetConfiguration,
  [methods.GEO_GET_NEARBY_COORDINATE]: GeoGetNearbyCoordinate,
  [methods.GEO_GET_NEARBY_DISTANCE]: GeoGetNearbyDistance,
  [methods.GEO_GET_REGISTER_STATUS]: GeoGetRegisterStatus,
  [methods.GEO_REGISTER]: GeoRegister,
  [methods.GEO_UPDATE_COMMENT]: GeoUpdateComment,
  [methods.GEO_UPDATE_POSITION]: GeoUpdatePosition,
  [methods.GROUP_ADD_ADMIN]: GroupAddAdmin,
  [methods.GROUP_ADD_MEMBER]: GroupAddMember,
  [methods.GROUP_ADD_MODERATOR]: GroupAddModerator,
  [methods.GROUP_AVATAR_ADD]: GroupAvatarAdd,
  [methods.GROUP_AVATAR_DELETE]: GroupAvatarDelete,
  [methods.GROUP_AVATAR_GET_LIST]: GroupAvatarGetList,
  [methods.GROUP_CHANGE_MEMBER_RIGHTS]: GroupChangeMemberRights,
  [methods.GROUP_CHECK_USERNAME]: GroupCheckUsername,
  [methods.GROUP_CLEAR_MESSAGE]: GroupClearMessage,
  [methods.GROUP_CREATE]: GroupCreate,
  [methods.GROUP_DELETE]: GroupDelete,
  [methods.GROUP_DELETE_MESSAGE]: GroupDeleteMessage,
  [methods.GROUP_EDIT]: GroupEdit,
  [methods.GROUP_EDIT_MESSAGE]: GroupEditMessage,
  [methods.GROUP_GET_DRAFT]: GroupGetDraft,
  [methods.GROUP_GET_MEMBER_LIST]: GroupGetMemberList,
  [methods.GROUP_KICK_ADMIN]: GroupKickAdmin,
  [methods.GROUP_KICK_MEMBER]: GroupKickMember,
  [methods.GROUP_KICK_MODERATOR]: GroupKickModerator,
  [methods.GROUP_LEFT]: GroupLeft,
  [methods.GROUP_PIN_MESSAGE]: GroupPinMessage,
  [methods.GROUP_REMOVE_USERNAME]: GroupRemoveUsername,
  [methods.GROUP_REVOKE_LINK]: GroupRevokeLink,
  [methods.GROUP_SEND_MESSAGE]: GroupSendMessage,
  [methods.GROUP_SET_ACTION]: GroupSetAction,
  [methods.GROUP_UPDATE_DRAFT]: GroupUpdateDraft,
  [methods.GROUP_UPDATE_STATUS]: GroupUpdateStatus,
  [methods.GROUP_UPDATE_USERNAME]: GroupUpdateUsername,
  [methods.HEARTBEAT]: Heartbeat,
  [methods.INFO_CONFIG]: InfoConfig,
  [methods.INFO_COUNTRY]: InfoCountry,
  [methods.INFO_LOCATION]: InfoLocation,
  [methods.INFO_PAGE]: InfoPage,
  [methods.INFO_TIME]: InfoTime,
  [methods.INFO_WALLPAPER]: InfoWallpaper,
  [methods.INFO_UPDATE]: InfoUpdate,
  [methods.MPL_GET_BILL_TOKEN]: MplGetBillToken,
  [methods.MPL_GET_SALES_TOKEN]: MplGetSalesToken,
  [methods.MPL_GET_TOPUP_TOKEN]: MplGetTopupToken,
  [methods.MPL_GET_TRANSACTION_LIST]: MplTransactionList,
  [methods.MPL_GET_TRANSACTION_INFO]: MplTransactionInfo,
  [methods.QR_CODE_ADD_CONTACT]: QrCodeAddContact,
  [methods.QR_CODE_ADD_ME]: QrCodeAddMe,
  [methods.QR_CODE_JOIN]: QrCodeJoin,
  [methods.QR_CODE_NEW_DEVICE]: QrCodeNewDevice,
  [methods.QR_CODE_RESOLVE]: QrCodeResolve,
  [methods.SIGNALING_ACCEPT]: SignalingAccept,
  [methods.SIGNALING_CANDIDATE]: SignalingCandidate,
  [methods.SIGNALING_CLEAR_LOG]: SignalingClearLog,
  [methods.SIGNALING_GET_CONFIGURATION]: SignalingGetConfiguration,
  [methods.SIGNALING_GET_LOG]: SignalingGetLog,
  [methods.SIGNALING_LEAVE]: SignalingLeave,
  [methods.SIGNALING_OFFER]: SignalingOffer,
  [methods.SIGNALING_RATE]: SignalingRate,
  [methods.SIGNALING_RINGING]: SignalingRinging,
  [methods.SIGNALING_SESSION_HOLD]: SignalingSessionHold,
  [methods.USER_AVATAR_ADD]: UserAvatarAdd,
  [methods.USER_AVATAR_DELETE]: UserAvatarDelete,
  [methods.USER_AVATAR_GET_LIST]: UserAvatarGetList,
  [methods.USER_CONTACTS_BLOCK]: UserContactsBlock,
  [methods.USER_CONTACTS_DELETE]: UserContactsDelete,
  [methods.USER_CONTACTS_EDIT]: UserContactsEdit,
  [methods.USER_CONTACTS_GET_BLOCKED_LIST]: UserContactsGetBlockedList,
  [methods.USER_CONTACTS_GET_LIST]: UserContactsGetList,
  [methods.USER_CONTACTS_IMPORT]: UserContactsImport,
  [methods.USER_CONTACTS_UNBLOCK]: UserContactsUnblock,
  [methods.USER_DELETE]: UserDelete,
  [methods.USER_GET_DELETE_TOKEN]: UserGetDeleteToken,
  [methods.USER_INFO]: UserInfo,
  [methods.USER_IVAND_GET_ACTIVITIES]: UserIVandGetActivities,
  [methods.USER_IVAND_GET_SCORE]: UserIVandGetScore,
  [methods.USER_IVAND_SET_ACTIVITY]: UserIVandSetActivity,
  [methods.USER_LOGIN]: UserLogin,
  [methods.USER_PRIVACY_GET_RULE]: UserPrivacyGetRule,
  [methods.USER_PRIVACY_SET_RULE]: UserPrivacySetRule,
  [methods.USER_PROFILE_CHECK_USERNAME]: UserProfileCheckUsername,
  [methods.USER_PROFILE_GET_BIO]: UserProfileGetBio,
  [methods.USER_PROFILE_GET_EMAIL]: UserProfileGetEmail,
  [methods.USER_PROFILE_GET_GENDER]: UserProfileGetGender,
  [methods.USER_PROFILE_GET_NICKNAME]: UserProfileGetNickname,
  [methods.USER_PROFILE_GET_REPRESENTATIVE]: UserProfileGetRepresentative,
  [methods.USER_PROFILE_GET_SELF_REMOVE]: UserProfileGetSelfRemove,
  [methods.USER_PROFILE_SET_BIO]: UserProfileSetBio,
  [methods.USER_PROFILE_SET_EMAIL]: UserProfileSetEmail,
  [methods.USER_PROFILE_SET_GENDER]: UserProfileSetGender,
  [methods.USER_PROFILE_SET_NICKNAME]: UserProfileSetNickname,
  [methods.USER_PROFILE_SET_REPRESENTATIVE]: UserProfileSetRepresentative,
  [methods.USER_PROFILE_SET_SELF_REMOVE]: UserProfileSetSelfRemove,
  [methods.USER_PROFILE_UPDATE_USERNAME]: UserProfileUpdateUsername,
  [methods.USER_REGISTER]: UserRegister,
  [methods.USER_REPORT]: UserReport,
  [methods.USER_SESSION_GET_ACTIVE_LIST]: UserSessionGetActiveList,
  [methods.USER_SESSION_LOGOUT]: UserSessionLogout,
  [methods.USER_SESSION_TERMINATE]: UserSessionTerminate,
  [methods.USER_SET_BOT]: UserSetBot,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_HINT]: UserTwoStepVerificationChangeHint,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL]: UserTwoStepVerificationChangeRecoveryEmail,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION]: UserTwoStepVerificationChangeRecoveryQuestion,
  [methods.USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD]: UserTwoStepVerificationCheckPassword,
  [methods.USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL]: UserTwoStepVerificationGetPasswordDetail,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS]: UserTwoStepVerificationRecoverPasswordByAnswers,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN]: UserTwoStepVerificationRecoverPasswordByToken,
  [methods.USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN]: UserTwoStepVerificationRequestRecoveryToken,
  [methods.USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL]: UserTwoStepVerificationResendVerifyEmail,
  [methods.USER_TWO_STEP_VERIFICATION_SET_PASSWORD]: UserTwoStepVerificationSetPassword,
  [methods.USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD]: UserTwoStepVerificationUnsetPassword,
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD]: UserTwoStepVerificationVerifyPassword,
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL]: UserTwoStepVerificationVerifyRecoveryEmail,
  [methods.USER_UPDATE_STATUS]: UserUpdateStatus,
  [methods.USER_USERNAME_TO_ID]: UserUsernameToId,
  [methods.USER_VERIFY]: UserVerify,
  [methods.USER_VERIFY_NEW_DEVICE]: UserVerifyNewDevice,
  [methods.WALLET_GET_ACCESS_TOKEN]: WalletGetAccessToken,
  [methods.WALLET_ID_MAPPING]: WalletIdMapping,
  [methods.WALLET_PAYMENT_INIT]: WalletPaymentInit,
  [methods.WALLET_REGISTER]: WalletRegister,
  [methods.STORY_GET_STORIES]: StoryGetStories,
  [methods.STORY_ADD_STORIES]: StoryUserAddNew,
  [methods.STORY_ADD_VIEW]: StoryAddView,
  [methods.STORY_GET_OWN_STORY_VIEWS]: StoryGetOwnStoryViews,
  [methods.STORY_DELETE_STORY]: StoryDeleteStory,
  [methods.CLIENT_ROOM_CHANGE_OWNER]: ClientRoomChangeOwner,
  [methods.CLIENT_SEARCH]: ClientSearch,
  [methods.USER_CHANGE_PHONE_NUMBER]: ChangePhoneNumber,
  [methods.USER_VERIFY_NEW_PHONE_NUMBER]: VerifyNewPhoneNumber,
  [methods.CLIENT_ROOM_MEMBER_SEARCH]: ClientRoomMemberSearch,
  [methods.GROUP_ROOM_MEMBER_MENTION]: GroupRoomMemberMention,
};

export const protoResponsesTable = {
  [methods.BILL_INQUIRY_MCI_RESPONSE]: BillInquiryMciResponse,
  [methods.BILL_INQUIRY_TELECOM_RESPONSE]: BillInquiryTelecomResponse,
  [methods.CHANNEL_ADD_ADMIN_RESPONSE]: ChannelAddAdminResponse,
  [methods.CHANNEL_ADD_MEMBER_RESPONSE]: ChannelAddMemberResponse,
  [methods.CHANNEL_ADD_MESSAGE_REACTION_RESPONSE]: ChannelAddMessageReactionResponse,
  [methods.CHANNEL_ADD_MODERATOR_RESPONSE]: ChannelAddModeratorResponse,
  [methods.CHANNEL_AVATAR_ADD_RESPONSE]: ChannelAvatarAddResponse,
  [methods.CHANNEL_AVATAR_DELETE_RESPONSE]: ChannelAvatarDeleteResponse,
  [methods.CHANNEL_AVATAR_GET_LIST_RESPONSE]: ChannelAvatarGetListResponse,
  [methods.CHANNEL_CHECK_USERNAME_RESPONSE]: ChannelCheckUsernameResponse,
  [methods.CHANNEL_CREATE_RESPONSE]: ChannelCreateResponse,
  [methods.CHANNEL_DELETE_MESSAGE_RESPONSE]: ChannelDeleteMessageResponse,
  [methods.CHANNEL_DELETE_RESPONSE]: ChannelDeleteResponse,
  [methods.CHANNEL_EDIT_MESSAGE_RESPONSE]: ChannelEditMessageResponse,
  [methods.CHANNEL_EDIT_RESPONSE]: ChannelEditResponse,
  [methods.CHANNEL_GET_DRAFT_RESPONSE]: ChannelGetDraftResponse,
  [methods.CHANNEL_GET_MEMBER_LIST_RESPONSE]: ChannelGetMemberListResponse,
  [methods.CHANNEL_GET_MESSAGES_STATS_RESPONSE]: ChannelGetMessagesStatsResponse,
  [methods.CHANNEL_KICK_ADMIN_RESPONSE]: ChannelKickAdminResponse,
  [methods.CHANNEL_KICK_MEMBER_RESPONSE]: ChannelKickMemberResponse,
  [methods.CHANNEL_KICK_MODERATOR_RESPONSE]: ChannelKickModeratorResponse,
  [methods.CHANNEL_LEFT_RESPONSE]: ChannelLeftResponse,
  [methods.CHANNEL_PIN_MESSAGE_RESPONSE]: ChannelPinMessageResponse,
  [methods.CHANNEL_REMOVE_USERNAME_RESPONSE]: ChannelRemoveUsernameResponse,
  [methods.CHANNEL_REVOKE_LINK_RESPONSE]: ChannelRevokeLinkResponse,
  [methods.CHANNEL_SEND_MESSAGE_RESPONSE]: ChannelSendMessageResponse,
  [methods.CHANNEL_UPDATE_DRAFT_RESPONSE]: ChannelUpdateDraftResponse,
  [methods.CHANNEL_UPDATE_REACTION_STATUS_RESPONSE]: ChannelUpdateReactionStatusResponse,
  [methods.CHANNEL_UPDATE_SIGNATURE_RESPONSE]: ChannelUpdateSignatureResponse,
  [methods.CHANNEL_UPDATE_USERNAME_RESPONSE]: ChannelUpdateUsernameResponse,
  [methods.CHAT_CLEAR_MESSAGE_RESPONSE]: ChatClearMessageResponse,
  [methods.CHAT_CONVERT_TO_GROUP_RESPONSE]: ChatConvertToGroupResponse,
  [methods.CHAT_DELETE_MESSAGE_RESPONSE]: ChatDeleteMessageResponse,
  [methods.CHAT_DELETE_RESPONSE]: ChatDeleteResponse,
  [methods.CHAT_EDIT_MESSAGE_RESPONSE]: ChatEditMessageResponse,
  [methods.CHAT_GET_DRAFT_RESPONSE]: ChatGetDraftResponse,
  [methods.CHAT_GET_ROOM_RESPONSE]: ChatGetRoomResponse,
  [methods.CHAT_SEND_MESSAGE_RESPONSE]: ChatSendMessageResponse,
  [methods.CHAT_SET_ACTION_RESPONSE]: ChatSetActionResponse,
  [methods.CHAT_UPDATE_DRAFT_RESPONSE]: ChatUpdateDraftResponse,
  [methods.CHAT_UPDATE_STATUS_RESPONSE]: ChatUpdateStatusResponse,
  [methods.CLIENT_CHECK_INVITE_LINK_RESPONSE]: ClientCheckInviteLinkResponse,
  [methods.CLIENT_CONDITION_RESPONSE]: ClientConditionResponse,
  [methods.CLIENT_COUNT_ROOM_HISTORY_RESPONSE]: ClientCountRoomHistoryResponse,
  [methods.CLIENT_GET_DISCOVERY_RESPONSE]: ClientGetDiscoveryResponse,
  [methods.CLIENT_GET_FAVORITE_MENU_RESPONSE]: ClientGetFavoriteMenuResponse,
  [methods.CLIENT_GET_POLL_RESPONSE]: ClientGetPollResponse,
  [methods.CLIENT_GET_PROMOTE_RESPONSE]: ClientGetPromoteResponse,
  [methods.CLIENT_GET_ROOM_HISTORY_RESPONSE]: ClientGetRoomHistoryResponse,
  [methods.CLIENT_GET_ROOM_LIST_RESPONSE]: ClientGetRoomListResponse,
  [methods.CLIENT_GET_ROOM_MESSAGE_RESPONSE]: ClientGetRoomMessageResponse,
  [methods.CLIENT_GET_ROOM_RESPONSE]: ClientGetRoomResponse,
  [methods.CLIENT_JOIN_BY_INVITE_LINK_RESPONSE]: ClientJoinByInviteLinkResponse,
  [methods.CLIENT_JOIN_BY_USERNAME_RESPONSE]: ClientJoinByUsernameResponse,
  [methods.CLIENT_MUTE_ROOM_RESPONSE]: ClientMuteRoomResponse,
  [methods.CLIENT_PIN_ROOM_RESPONSE]: ClientPinRoomResponse,
  [methods.CLIENT_REGISTER_DEVICE_RESPONSE]: ClientRegisterDeviceResponse,
  [methods.CLIENT_RESOLVE_USERNAME_RESPONSE]: ClientResolveUsernameResponse,
  [methods.CLIENT_ROOM_REPORT_RESPONSE]: ClientRoomReportResponse,
  [methods.CLIENT_SEARCH_ROOM_HISTORY_RESPONSE]: ClientSearchRoomHistoryResponse,
  [methods.CLIENT_SEARCH_USERNAME_RESPONSE]: ClientSearchUsernameResponse,
  [methods.CLIENT_SET_DISCOVERY_ITEM_AGREEMENT_RESPONSE]: ClientSetDiscoveryItemAgreementResponse,
  [methods.CLIENT_SET_DISCOVERY_ITEM_CLICK_RESPONSE]: ClientSetDiscoveryItemClickResponse,
  [methods.CLIENT_SET_POLL_ITEM_CLICK_RESPONSE]: ClientSetPollItemClickResponse,
  [methods.CLIENT_SUBSCRIBE_TO_ROOM_RESPONSE]: ClientSubscribeToRoomResponse,
  [methods.CLIENT_UNSUBSCRIBE_FROM_ROOM_RESPONSE]: ClientUnsubscribeFromRoomResponse,
  [methods.CONNECTION_SECURING_RESPONSE]: ConnectionSecuringResponse,
  [methods.CONNECTION_SYMMETRIC_KEY_RESPONSE]: ConnectionSymmetricKeyResponse,
  [methods.ERROR_RESPONSE]: ErrorResponse,
  [methods.FILE_DOWNLOAD_RESPONSE]: FileDownloadResponse,
  [methods.FILE_INFO_RESPONSE]: FileInfoResponse,
  [methods.FILE_UPLOAD_INIT_RESPONSE]: FileUploadInitResponse,
  [methods.FILE_UPLOAD_OPTION_RESPONSE]: FileUploadOptionResponse,
  [methods.FILE_UPLOAD_RESPONSE]: FileUploadResponse,
  [methods.FILE_UPLOAD_STATUS_RESPONSE]: FileUploadStatusResponse,
  [methods.GEO_GET_COMMENT_RESPONSE]: GeoGetCommentResponse,
  [methods.GEO_GET_CONFIGURATION_RESPONSE]: GeoGetConfigurationResponse,
  [methods.GEO_GET_NEARBY_COORDINATE_RESPONSE]: GeoGetNearbyCoordinateResponse,
  [methods.GEO_GET_NEARBY_DISTANCE_RESPONSE]: GeoGetNearbyDistanceResponse,
  [methods.GEO_GET_REGISTER_STATUS_RESPONSE]: GeoGetRegisterStatusResponse,
  [methods.GEO_REGISTER_RESPONSE]: GeoRegisterResponse,
  [methods.GEO_UPDATE_COMMENT_RESPONSE]: GeoUpdateCommentResponse,
  [methods.GEO_UPDATE_POSITION_RESPONSE]: GeoUpdatePositionResponse,
  [methods.GROUP_ADD_ADMIN_RESPONSE]: GroupAddAdminResponse,
  [methods.GROUP_ADD_MEMBER_RESPONSE]: GroupAddMemberResponse,
  [methods.GROUP_ADD_MODERATOR_RESPONSE]: GroupAddModeratorResponse,
  [methods.GROUP_AVATAR_ADD_RESPONSE]: GroupAvatarAddResponse,
  [methods.GROUP_AVATAR_DELETE_RESPONSE]: GroupAvatarDeleteResponse,
  [methods.GROUP_AVATAR_GET_LIST_RESPONSE]: GroupAvatarGetListResponse,
  [methods.GROUP_CHANGE_MEMBER_RIGHTS_RESPONSE]: GroupChangeMemberRightsResponse,
  [methods.GROUP_CHECK_USERNAME_RESPONSE]: GroupCheckUsernameResponse,
  [methods.GROUP_CLEAR_MESSAGE_RESPONSE]: GroupClearMessageResponse,
  [methods.GROUP_CREATE_RESPONSE]: GroupCreateResponse,
  [methods.GROUP_DELETE_MESSAGE_RESPONSE]: GroupDeleteMessageResponse,
  [methods.GROUP_DELETE_RESPONSE]: GroupDeleteResponse,
  [methods.GROUP_EDIT_MESSAGE_RESPONSE]: GroupEditMessageResponse,
  [methods.GROUP_EDIT_RESPONSE]: GroupEditResponse,
  [methods.GROUP_GET_DRAFT_RESPONSE]: GroupGetDraftResponse,
  [methods.GROUP_GET_MEMBER_LIST_RESPONSE]: GroupGetMemberListResponse,
  [methods.GROUP_KICK_ADMIN_RESPONSE]: GroupKickAdminResponse,
  [methods.GROUP_KICK_MEMBER_RESPONSE]: GroupKickMemberResponse,
  [methods.GROUP_KICK_MODERATOR_RESPONSE]: GroupKickModeratorResponse,
  [methods.GROUP_LEFT_RESPONSE]: GroupLeftResponse,
  [methods.GROUP_PIN_MESSAGE_RESPONSE]: GroupPinMessageResponse,
  [methods.GROUP_REMOVE_USERNAME_RESPONSE]: GroupRemoveUsernameResponse,
  [methods.GROUP_REVOKE_LINK_RESPONSE]: GroupRevokeLinkResponse,
  [methods.GROUP_SEND_MESSAGE_RESPONSE]: GroupSendMessageResponse,
  [methods.GROUP_SET_ACTION_RESPONSE]: GroupSetActionResponse,
  [methods.GROUP_UPDATE_DRAFT_RESPONSE]: GroupUpdateDraftResponse,
  [methods.GROUP_UPDATE_STATUS_RESPONSE]: GroupUpdateStatusResponse,
  [methods.GROUP_UPDATE_USERNAME_RESPONSE]: GroupUpdateUsernameResponse,
  [methods.HEARTBEAT_RESPONSE]: HeartbeatResponse,
  [methods.INFO_CONFIG_RESPONSE]: InfoConfigResponse,
  [methods.INFO_COUNTRY_RESPONSE]: InfoCountryResponse,
  [methods.INFO_LOCATION_RESPONSE]: InfoLocationResponse,
  [methods.INFO_PAGE_RESPONSE]: InfoPageResponse,
  [methods.INFO_TIME_RESPONSE]: InfoTimeResponse,
  [methods.INFO_WALLPAPER_RESPONSE]: InfoWallpaperResponse,
  [methods.INFO_UPDATE_RESPONSE]: InfoUpdateResponse,
  [methods.MPL_GET_BILL_TOKEN_RESPONSE]: MplGetBillTokenResponse,
  [methods.MPL_GET_SALES_TOKEN_RESPONSE]: MplGetSalesTokenResponse,
  [methods.MPL_GET_TOPUP_TOKEN_RESPONSE]: MplGetTopupTokenResponse,
  [methods.MPL_GET_TRANSACTION_LIST_RESPONSE]: MplTransactionListResponse,
  [methods.MPL_GET_TRANSACTION_INFO_RESPONSE]: MplTransactionInfoResponse,
  [methods.PUSH_LOGIN_TOKEN_RESPONSE]: PushLoginTokenResponse,
  [methods.PUSH_RATE_SIGNALING_RESPONSE]: PushRateSignalingResponse,
  [methods.PUSH_TWO_STEP_VERIFICATION_RESPONSE]: PushTwoStepVerificationResponse,
  [methods.PUSH_USER_INFO_EXPIRED_RESPONSE]: PushUserInfoExpiredResponse,
  [methods.PUSH_WALLET_PAYMENT_VERIFIED_RESPONSE]: PushWalletPaymentVerifiedResponse,
  [methods.QR_CODE_ADD_CONTACT_RESPONSE]: QrCodeAddContactResponse,
  [methods.QR_CODE_ADD_ME_RESPONSE]: QrCodeAddMeResponse,
  [methods.QR_CODE_JOIN_RESPONSE]: QrCodeJoinResponse,
  [methods.QR_CODE_NEW_DEVICE_RESPONSE]: QrCodeNewDeviceResponse,
  [methods.QR_CODE_RESOLVE_RESPONSE]: QrCodeResolveResponse,
  [methods.SIGNALING_ACCEPT_RESPONSE]: SignalingAcceptResponse,
  [methods.SIGNALING_CANDIDATE_RESPONSE]: SignalingCandidateResponse,
  [methods.SIGNALING_CLEAR_LOG_RESPONSE]: SignalingClearLogResponse,
  [methods.SIGNALING_GET_CONFIGURATION_RESPONSE]: SignalingGetConfigurationResponse,
  [methods.SIGNALING_GET_LOG_RESPONSE]: SignalingGetLogResponse,
  [methods.SIGNALING_LEAVE_RESPONSE]: SignalingLeaveResponse,
  [methods.SIGNALING_OFFER_RESPONSE]: SignalingOfferResponse,
  [methods.SIGNALING_RATE_RESPONSE]: SignalingRateResponse,
  [methods.SIGNALING_RINGING_RESPONSE]: SignalingRingingResponse,
  [methods.SIGNALING_SESSION_HOLD_RESPONSE]: SignalingSessionHoldResponse,
  [methods.USER_AVATAR_ADD_RESPONSE]: UserAvatarAddResponse,
  [methods.USER_AVATAR_DELETE_RESPONSE]: UserAvatarDeleteResponse,
  [methods.USER_AVATAR_GET_LIST_RESPONSE]: UserAvatarGetListResponse,
  [methods.USER_CONTACTS_BLOCK_RESPONSE]: UserContactsBlockResponse,
  [methods.USER_CONTACTS_DELETE_RESPONSE]: UserContactsDeleteResponse,
  [methods.USER_CONTACTS_EDIT_RESPONSE]: UserContactsEditResponse,
  [methods.USER_CONTACTS_GET_BLOCKED_LIST_RESPONSE]: UserContactsGetBlockedListResponse,
  [methods.USER_CONTACTS_GET_LIST_RESPONSE]: UserContactsGetListResponse,
  [methods.USER_CONTACTS_IMPORT_RESPONSE]: UserContactsImportResponse,
  [methods.USER_CONTACTS_UNBLOCK_RESPONSE]: UserContactsUnblockResponse,
  [methods.USER_DELETE_RESPONSE]: UserDeleteResponse,
  [methods.USER_GET_DELETE_TOKEN_RESPONSE]: UserGetDeleteTokenResponse,
  [methods.USER_INFO_RESPONSE]: UserInfoResponse,
  [methods.USER_IVAND_GET_ACTIVITIES_RESPONSE]: UserIVandGetActivitiesResponse,
  [methods.USER_IVAND_GET_SCORE_RESPONSE]: UserIVandGetScoreResponse,
  [methods.USER_IVAND_SET_ACTIVITY_RESPONSE]: UserIVandSetActivityResponse,
  [methods.USER_LOGIN_RESPONSE]: UserLoginResponse,
  [methods.USER_PRIVACY_GET_RULE_RESPONSE]: UserPrivacyGetRuleResponse,
  [methods.USER_PRIVACY_SET_RULE_RESPONSE]: UserPrivacySetRuleResponse,
  [methods.USER_PROFILE_CHECK_USERNAME_RESPONSE]: UserProfileCheckUsernameResponse,
  [methods.USER_PROFILE_GET_BIO_RESPONSE]: UserProfileGetBioResponse,
  [methods.USER_PROFILE_GET_EMAIL_RESPONSE]: UserProfileGetEmailResponse,
  [methods.USER_PROFILE_GET_GENDER_RESPONSE]: UserProfileGetGenderResponse,
  [methods.USER_PROFILE_GET_NICKNAME_RESPONSE]: UserProfileGetNicknameResponse,
  [methods.USER_PROFILE_GET_REPRESENTATIVE_RESPONSE]: UserProfileGetRepresentativeResponse,
  [methods.USER_PROFILE_GET_SELF_REMOVE_RESPONSE]: UserProfileGetSelfRemoveResponse,
  [methods.USER_PROFILE_SET_BIO_RESPONSE]: UserProfileSetBioResponse,
  [methods.USER_PROFILE_SET_EMAIL_RESPONSE]: UserProfileSetEmailResponse,
  [methods.USER_PROFILE_SET_GENDER_RESPONSE]: UserProfileSetGenderResponse,
  [methods.USER_PROFILE_SET_NICKNAME_RESPONSE]: UserProfileSetNicknameResponse,
  [methods.USER_PROFILE_SET_REPRESENTATIVE_RESPONSE]: UserProfileSetRepresentativeResponse,
  [methods.USER_PROFILE_SET_SELF_REMOVE_RESPONSE]: UserProfileSetSelfRemoveResponse,
  [methods.USER_PROFILE_UPDATE_USERNAME_RESPONSE]: UserProfileUpdateUsernameResponse,
  [methods.USER_REGISTER_RESPONSE]: UserRegisterResponse,
  [methods.USER_REPORT_RESPONSE]: UserReportResponse,
  [methods.USER_SESSION_GET_ACTIVE_LIST_RESPONSE]: UserSessionGetActiveListResponse,
  [methods.USER_SESSION_LOGOUT_RESPONSE]: UserSessionLogoutResponse,
  [methods.USER_SESSION_TERMINATE_RESPONSE]: UserSessionTerminateResponse,
  [methods.USER_SET_BOT_RESPONSE]: UserSetBotResponse,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_HINT_RESPONSE]: UserTwoStepVerificationChangeHintResponse,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL_RESPONSE]: UserTwoStepVerificationChangeRecoveryEmailResponse,
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION_RESPONSE]: UserTwoStepVerificationChangeRecoveryQuestionResponse,
  [methods.USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD_RESPONSE]: UserTwoStepVerificationCheckPasswordResponse,
  [methods.USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL_RESPONSE]: UserTwoStepVerificationGetPasswordDetailResponse,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS_RESPONSE]: UserTwoStepVerificationRecoverPasswordByAnswersResponse,
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN_RESPONSE]: UserTwoStepVerificationRecoverPasswordByTokenResponse,
  [methods.USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN_RESPONSE]: UserTwoStepVerificationRequestRecoveryTokenResponse,
  [methods.USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL_RESPONSE]: UserTwoStepVerificationResendVerifyEmailResponse,
  [methods.USER_TWO_STEP_VERIFICATION_SET_PASSWORD_RESPONSE]: UserTwoStepVerificationSetPasswordResponse,
  [methods.USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD_RESPONSE]: UserTwoStepVerificationUnsetPasswordResponse,
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD_RESPONSE]: UserTwoStepVerificationVerifyPasswordResponse,
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL_RESPONSE]: UserTwoStepVerificationVerifyRecoveryEmailResponse,
  [methods.USER_UPDATE_STATUS_RESPONSE]: UserUpdateStatusResponse,
  [methods.USER_USERNAME_TO_ID_RESPONSE]: UserUsernameToIdResponse,
  [methods.USER_VERIFY_NEW_DEVICE_RESPONSE]: UserVerifyNewDeviceResponse,
  [methods.USER_VERIFY_RESPONSE]: UserVerifyResponse,
  [methods.WALLET_GET_ACCESS_TOKEN_RESPONSE]: WalletGetAccessTokenResponse,
  [methods.WALLET_ID_MAPPING_RESPONSE]: WalletIdMappingResponse,
  [methods.WALLET_PAYMENT_INIT_RESPONSE]: WalletPaymentInitResponse,
  [methods.WALLET_REGISTER_RESPONSE]: WalletRegisterResponse,
  [methods.STORY_GET_STORIES_RESPONSE]: StoryGetStoriesResponse,
  [methods.STORY_ADD_STORIES_RESPONSE]: StoryUserAddNewResponse,
  [methods.STORY_ADD_VIEW_RESPONSE]: StoryAddViewResponse,
  [methods.STORY_GET_OWN_STORY_VIEWS_RESPONSE]: StoryGetOwnStoryViewsResponse,
  [methods.STORY_DELETE_STORY_RESPONSE]: StoryDeleteStoryResponse,
  [methods.CLIENT_ROOM_CHANGE_OWNER]: ClientRoomChangeOwnerResponse,
  [methods.CLIENT_SEARCH_RESPONSE]: ClientSearchResponse,
  [methods.CLIENT_ROOM_CHANGE_OWNER_RESPONSE]: ClientRoomChangeOwnerResponse,
  [methods.USER_CHANGE_PHONE_NUMBER_RESPONSE]: ChangePhoneNumberResponse,
  [methods.USER_VERIFY_NEW_PHONE_NUMBER_RESPONSE]: ChangePhoneNumberResponse,
  [methods.CLIENT_ROOM_MEMBER_SEARCH_RESPONSE]: ClientRoomMemberSearchResponse,
};

export type protoRequestsObjectType = {
  [methods.BILL_INQUIRY_MCI]: BillInquiryMci.AsObject;
  [methods.BILL_INQUIRY_TELECOM]: BillInquiryTelecom.AsObject;
  [methods.CHANNEL_ADD_ADMIN]: ChannelAddAdmin.AsObject;
  [methods.CHANNEL_ADD_MEMBER]: ChannelAddMember.AsObject;
  [methods.CHANNEL_ADD_MESSAGE_REACTION]: ChannelAddMessageReaction.AsObject;
  [methods.CHANNEL_ADD_MODERATOR]: ChannelAddModerator.AsObject;
  [methods.CHANNEL_AVATAR_ADD]: ChannelAvatarAdd.AsObject;
  [methods.CHANNEL_AVATAR_DELETE]: ChannelAvatarDelete.AsObject;
  [methods.CHANNEL_AVATAR_GET_LIST]: ChannelAvatarGetList.AsObject;
  [methods.CHANNEL_CHECK_USERNAME]: ChannelCheckUsername.AsObject;
  [methods.CHANNEL_CREATE]: ChannelCreate.AsObject;
  [methods.CHANNEL_DELETE]: ChannelDelete.AsObject;
  [methods.CHANNEL_DELETE_MESSAGE]: ChannelDeleteMessage.AsObject;
  [methods.CHANNEL_EDIT]: ChannelEdit.AsObject;
  [methods.CHANNEL_EDIT_MESSAGE]: ChannelEditMessage.AsObject;
  [methods.CHANNEL_GET_DRAFT]: ChannelGetDraft.AsObject;
  [methods.CHANNEL_GET_MEMBER_LIST]: ChannelGetMemberList.AsObject;
  [methods.CHANNEL_GET_MESSAGES_STATS]: ChannelGetMessagesStats.AsObject;
  [methods.CHANNEL_KICK_ADMIN]: ChannelKickAdmin.AsObject;
  [methods.CHANNEL_KICK_MEMBER]: ChannelKickMember.AsObject;
  [methods.CHANNEL_KICK_MODERATOR]: ChannelKickModerator.AsObject;
  [methods.CHANNEL_LEFT]: ChannelLeft.AsObject;
  [methods.CHANNEL_PIN_MESSAGE]: ChannelPinMessage.AsObject;
  [methods.CHANNEL_REMOVE_USERNAME]: ChannelRemoveUsername.AsObject;
  [methods.CHANNEL_REVOKE_LINK]: ChannelRevokeLink.AsObject;
  [methods.CHANNEL_SEND_MESSAGE]: ChannelSendMessage.AsObject;
  [methods.CHANNEL_UPDATE_DRAFT]: ChannelUpdateDraft.AsObject;
  [methods.CHANNEL_UPDATE_REACTION_STATUS]: ChannelUpdateReactionStatus.AsObject;
  [methods.CHANNEL_UPDATE_SIGNATURE]: ChannelUpdateSignature.AsObject;
  [methods.CHANNEL_UPDATE_USERNAME]: ChannelUpdateUsername.AsObject;
  [methods.CHAT_CLEAR_MESSAGE]: ChatClearMessage.AsObject;
  [methods.CHAT_CONVERT_TO_GROUP]: ChatConvertToGroup.AsObject;
  [methods.CHAT_DELETE]: ChatDelete.AsObject;
  [methods.CHAT_DELETE_MESSAGE]: ChatDeleteMessage.AsObject;
  [methods.CHAT_EDIT_MESSAGE]: ChatEditMessage.AsObject;
  [methods.CHAT_GET_DRAFT]: ChatGetDraft.AsObject;
  [methods.CHAT_GET_ROOM]: ChatGetRoom.AsObject;
  [methods.CHAT_SEND_MESSAGE]: ChatSendMessage.AsObject;
  [methods.CHAT_SET_ACTION]: ChatSetAction.AsObject;
  [methods.CHAT_UPDATE_DRAFT]: ChatUpdateDraft.AsObject;
  [methods.CHAT_UPDATE_STATUS]: ChatUpdateStatus.AsObject;
  [methods.CLIENT_CHECK_INVITE_LINK]: ClientCheckInviteLink.AsObject;
  [methods.CLIENT_CONDITION]: ClientCondition.AsObject;
  [methods.CLIENT_COUNT_ROOM_HISTORY]: ClientCountRoomHistory.AsObject;
  [methods.CLIENT_GET_DISCOVERY]: ClientGetDiscovery.AsObject;
  [methods.CLIENT_GET_FAVORITE_MENU]: ClientGetFavoriteMenu.AsObject;
  [methods.CLIENT_GET_POLL]: ClientGetPoll.AsObject;
  [methods.CLIENT_GET_PROMOTE]: ClientGetPromote.AsObject;
  [methods.CLIENT_GET_ROOM]: ClientGetRoom.AsObject;
  [methods.CLIENT_GET_ROOM_HISTORY]: ClientGetRoomHistory.AsObject;
  [methods.CLIENT_GET_ROOM_LIST]: ClientGetRoomList.AsObject;
  [methods.CLIENT_GET_ROOM_MESSAGE]: ClientGetRoomMessage.AsObject;
  [methods.CLIENT_JOIN_BY_INVITE_LINK]: ClientJoinByInviteLink.AsObject;
  [methods.CLIENT_JOIN_BY_USERNAME]: ClientJoinByUsername.AsObject;
  [methods.CLIENT_MUTE_ROOM]: ClientMuteRoom.AsObject;
  [methods.CLIENT_PIN_ROOM]: ClientPinRoom.AsObject;
  [methods.CLIENT_REGISTER_DEVICE]: ClientRegisterDevice.AsObject;
  [methods.CLIENT_RESOLVE_USERNAME]: ClientResolveUsername.AsObject;
  [methods.CLIENT_ROOM_REPORT]: ClientRoomReport.AsObject;
  [methods.CLIENT_SEARCH_ROOM_HISTORY]: ClientSearchRoomHistory.AsObject;
  [methods.CLIENT_SEARCH_USERNAME]: ClientSearchUsername.AsObject;
  [methods.CLIENT_SET_DISCOVERY_ITEM_AGREEMENT]: ClientSetDiscoveryItemAgreement.AsObject;
  [methods.CLIENT_SET_DISCOVERY_ITEM_CLICK]: ClientSetDiscoveryItemClick.AsObject;
  [methods.CLIENT_SET_POLL_ITEM_CLICK]: ClientSetPollItemClick.AsObject;
  [methods.CLIENT_SUBSCRIBE_TO_ROOM]: ClientSubscribeToRoom.AsObject;
  [methods.CLIENT_UNSUBSCRIBE_FROM_ROOM]: ClientUnsubscribeFromRoom.AsObject;
  [methods.CONNECTION_SYMMETRIC_KEY]: ConnectionSymmetricKey.AsObject;
  [methods.FILE_DOWNLOAD]: FileDownload.AsObject;
  [methods.FILE_INFO]: FileInfo.AsObject;
  [methods.FILE_UPLOAD]: FileUpload.AsObject;
  [methods.FILE_UPLOAD_INIT]: FileUploadInit.AsObject;
  [methods.FILE_UPLOAD_OPTION]: FileUploadOption.AsObject;
  [methods.FILE_UPLOAD_STATUS]: FileUploadStatus.AsObject;
  [methods.GEO_GET_COMMENT]: GeoGetComment.AsObject;
  [methods.GEO_GET_CONFIGURATION]: GeoGetConfiguration.AsObject;
  [methods.GEO_GET_NEARBY_COORDINATE]: GeoGetNearbyCoordinate.AsObject;
  [methods.GEO_GET_NEARBY_DISTANCE]: GeoGetNearbyDistance.AsObject;
  [methods.GEO_GET_REGISTER_STATUS]: GeoGetRegisterStatus.AsObject;
  [methods.GEO_REGISTER]: GeoRegister.AsObject;
  [methods.GEO_UPDATE_COMMENT]: GeoUpdateComment.AsObject;
  [methods.GEO_UPDATE_POSITION]: GeoUpdatePosition.AsObject;
  [methods.GROUP_ADD_ADMIN]: GroupAddAdmin.AsObject;
  [methods.GROUP_ADD_MEMBER]: GroupAddMember.AsObject;
  [methods.GROUP_ADD_MODERATOR]: GroupAddModerator.AsObject;
  [methods.GROUP_AVATAR_ADD]: GroupAvatarAdd.AsObject;
  [methods.GROUP_AVATAR_DELETE]: GroupAvatarDelete.AsObject;
  [methods.GROUP_AVATAR_GET_LIST]: GroupAvatarGetList.AsObject;
  [methods.GROUP_CHANGE_MEMBER_RIGHTS]: GroupChangeMemberRights.AsObject;
  [methods.GROUP_CHECK_USERNAME]: GroupCheckUsername.AsObject;
  [methods.GROUP_CLEAR_MESSAGE]: GroupClearMessage.AsObject;
  [methods.GROUP_CREATE]: GroupCreate.AsObject;
  [methods.GROUP_DELETE]: GroupDelete.AsObject;
  [methods.GROUP_DELETE_MESSAGE]: GroupDeleteMessage.AsObject;
  [methods.GROUP_EDIT]: GroupEdit.AsObject;
  [methods.GROUP_EDIT_MESSAGE]: GroupEditMessage.AsObject;
  [methods.GROUP_GET_DRAFT]: GroupGetDraft.AsObject;
  [methods.GROUP_GET_MEMBER_LIST]: GroupGetMemberList.AsObject;
  [methods.GROUP_KICK_ADMIN]: GroupKickAdmin.AsObject;
  [methods.GROUP_KICK_MEMBER]: GroupKickMember.AsObject;
  [methods.GROUP_KICK_MODERATOR]: GroupKickModerator.AsObject;
  [methods.GROUP_LEFT]: GroupLeft.AsObject;
  [methods.GROUP_PIN_MESSAGE]: GroupPinMessage.AsObject;
  [methods.GROUP_REMOVE_USERNAME]: GroupRemoveUsername.AsObject;
  [methods.GROUP_REVOKE_LINK]: GroupRevokeLink.AsObject;
  [methods.GROUP_SEND_MESSAGE]: GroupSendMessage.AsObject;
  [methods.GROUP_SET_ACTION]: GroupSetAction.AsObject;
  [methods.GROUP_UPDATE_DRAFT]: GroupUpdateDraft.AsObject;
  [methods.GROUP_UPDATE_STATUS]: GroupUpdateStatus.AsObject;
  [methods.GROUP_UPDATE_USERNAME]: GroupUpdateUsername.AsObject;
  [methods.HEARTBEAT]: Heartbeat.AsObject;
  [methods.INFO_CONFIG]: InfoConfig.AsObject;
  [methods.INFO_COUNTRY]: InfoCountry.AsObject;
  [methods.INFO_LOCATION]: InfoLocation.AsObject;
  [methods.INFO_PAGE]: InfoPage.AsObject;
  [methods.INFO_TIME]: InfoTime.AsObject;
  [methods.INFO_WALLPAPER]: InfoWallpaper.AsObject;
  [methods.INFO_UPDATE]: InfoUpdate.AsObject;
  [methods.MPL_GET_BILL_TOKEN]: MplGetBillToken.AsObject;
  [methods.MPL_GET_SALES_TOKEN]: MplGetSalesToken.AsObject;
  [methods.MPL_GET_TOPUP_TOKEN]: MplGetTopupToken.AsObject;
  [methods.MPL_GET_TRANSACTION_LIST]: MplTransactionList.AsObject;
  [methods.MPL_GET_TRANSACTION_INFO]: MplTransactionInfo.AsObject;
  [methods.QR_CODE_ADD_CONTACT]: QrCodeAddContact.AsObject;
  [methods.QR_CODE_ADD_ME]: QrCodeAddMe.AsObject;
  [methods.QR_CODE_JOIN]: QrCodeJoin.AsObject;
  [methods.QR_CODE_NEW_DEVICE]: QrCodeNewDevice.AsObject;
  [methods.QR_CODE_RESOLVE]: QrCodeResolve.AsObject;
  [methods.SIGNALING_ACCEPT]: SignalingAccept.AsObject;
  [methods.SIGNALING_CANDIDATE]: SignalingCandidate.AsObject;
  [methods.SIGNALING_CLEAR_LOG]: SignalingClearLog.AsObject;
  [methods.SIGNALING_GET_CONFIGURATION]: SignalingGetConfiguration.AsObject;
  [methods.SIGNALING_GET_LOG]: SignalingGetLog.AsObject;
  [methods.SIGNALING_LEAVE]: SignalingLeave.AsObject;
  [methods.SIGNALING_OFFER]: SignalingOffer.AsObject;
  [methods.SIGNALING_RATE]: SignalingRate.AsObject;
  [methods.SIGNALING_RINGING]: SignalingRinging.AsObject;
  [methods.SIGNALING_SESSION_HOLD]: SignalingSessionHold.AsObject;
  [methods.USER_AVATAR_ADD]: UserAvatarAdd.AsObject;
  [methods.USER_AVATAR_DELETE]: UserAvatarDelete.AsObject;
  [methods.USER_AVATAR_GET_LIST]: UserAvatarGetList.AsObject;
  [methods.USER_CONTACTS_BLOCK]: UserContactsBlock.AsObject;
  [methods.USER_CONTACTS_DELETE]: UserContactsDelete.AsObject;
  [methods.USER_CONTACTS_EDIT]: UserContactsEdit.AsObject;
  [methods.USER_CONTACTS_GET_BLOCKED_LIST]: UserContactsGetBlockedList.AsObject;
  [methods.USER_CONTACTS_GET_LIST]: UserContactsGetList.AsObject;
  [methods.USER_CONTACTS_IMPORT]: UserContactsImport.AsObject;
  [methods.USER_CONTACTS_UNBLOCK]: UserContactsUnblock.AsObject;
  [methods.USER_DELETE]: UserDelete.AsObject;
  [methods.USER_GET_DELETE_TOKEN]: UserGetDeleteToken.AsObject;
  [methods.USER_INFO]: UserInfo.AsObject;
  [methods.USER_IVAND_GET_ACTIVITIES]: UserIVandGetActivities.AsObject;
  [methods.USER_IVAND_GET_SCORE]: UserIVandGetScore.AsObject;
  [methods.USER_IVAND_SET_ACTIVITY]: UserIVandSetActivity.AsObject;
  [methods.USER_LOGIN]: UserLogin.AsObject;
  [methods.USER_PRIVACY_GET_RULE]: UserPrivacyGetRule.AsObject;
  [methods.USER_PRIVACY_SET_RULE]: UserPrivacySetRule.AsObject;
  [methods.USER_PROFILE_CHECK_USERNAME]: UserProfileCheckUsername.AsObject;
  [methods.USER_PROFILE_GET_BIO]: UserProfileGetBio.AsObject;
  [methods.USER_PROFILE_GET_EMAIL]: UserProfileGetEmail.AsObject;
  [methods.USER_PROFILE_GET_GENDER]: UserProfileGetGender.AsObject;
  [methods.USER_PROFILE_GET_NICKNAME]: UserProfileGetNickname.AsObject;
  [methods.USER_PROFILE_GET_REPRESENTATIVE]: UserProfileGetRepresentative.AsObject;
  [methods.USER_PROFILE_GET_SELF_REMOVE]: UserProfileGetSelfRemove.AsObject;
  [methods.USER_PROFILE_SET_BIO]: UserProfileSetBio.AsObject;
  [methods.USER_PROFILE_SET_EMAIL]: UserProfileSetEmail.AsObject;
  [methods.USER_PROFILE_SET_GENDER]: UserProfileSetGender.AsObject;
  [methods.USER_PROFILE_SET_NICKNAME]: UserProfileSetNickname.AsObject;
  [methods.USER_PROFILE_SET_REPRESENTATIVE]: UserProfileSetRepresentative.AsObject;
  [methods.USER_PROFILE_SET_SELF_REMOVE]: UserProfileSetSelfRemove.AsObject;
  [methods.USER_PROFILE_UPDATE_USERNAME]: UserProfileUpdateUsername.AsObject;
  [methods.USER_REGISTER]: UserRegister.AsObject;
  [methods.USER_REPORT]: UserReport.AsObject;
  [methods.USER_SESSION_GET_ACTIVE_LIST]: UserSessionGetActiveList.AsObject;
  [methods.USER_SESSION_LOGOUT]: UserSessionLogout.AsObject;
  [methods.USER_SESSION_TERMINATE]: UserSessionTerminate.AsObject;
  [methods.USER_SET_BOT]: UserSetBot.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_HINT]: UserTwoStepVerificationChangeHint.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL]: UserTwoStepVerificationChangeRecoveryEmail.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION]: UserTwoStepVerificationChangeRecoveryQuestion.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD]: UserTwoStepVerificationCheckPassword.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL]: UserTwoStepVerificationGetPasswordDetail.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS]: UserTwoStepVerificationRecoverPasswordByAnswers.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN]: UserTwoStepVerificationRecoverPasswordByToken.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN]: UserTwoStepVerificationRequestRecoveryToken.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL]: UserTwoStepVerificationResendVerifyEmail.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_SET_PASSWORD]: UserTwoStepVerificationSetPassword.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD]: UserTwoStepVerificationUnsetPassword.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD]: UserTwoStepVerificationVerifyPassword.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL]: UserTwoStepVerificationVerifyRecoveryEmail.AsObject;
  [methods.USER_UPDATE_STATUS]: UserUpdateStatus.AsObject;
  [methods.USER_USERNAME_TO_ID]: UserUsernameToId.AsObject;
  [methods.USER_VERIFY]: UserVerify.AsObject;
  [methods.USER_VERIFY_NEW_DEVICE]: UserVerifyNewDevice.AsObject;
  [methods.WALLET_GET_ACCESS_TOKEN]: WalletGetAccessToken.AsObject;
  [methods.WALLET_ID_MAPPING]: WalletIdMapping.AsObject;
  [methods.WALLET_PAYMENT_INIT]: WalletPaymentInit.AsObject;
  [methods.WALLET_REGISTER]: WalletRegister.AsObject;
  [methods.STORY_GET_STORIES]: StoryGetStories.AsObject;
  [methods.STORY_ADD_STORIES]: StoryUserAddNew.AsObject;
  [methods.STORY_ADD_VIEW]: StoryAddView.AsObject;
  [methods.STORY_GET_OWN_STORY_VIEWS]: StoryGetOwnStoryViews.AsObject;
  [methods.STORY_DELETE_STORY]: StoryDeleteStory.AsObject;
  [methods.CLIENT_ROOM_CHANGE_OWNER]: ClientRoomChangeOwner.AsObject;
  [methods.CLIENT_SEARCH]: ClientSearch.AsObject;
  [methods.USER_CHANGE_PHONE_NUMBER]: ChangePhoneNumber.AsObject;
  [methods.USER_VERIFY_NEW_PHONE_NUMBER]: VerifyNewPhoneNumber.AsObject;
  [methods.CLIENT_ROOM_MEMBER_SEARCH]: ClientRoomMemberSearch.AsObject;
  [methods.GROUP_ROOM_MEMBER_MENTION]: GroupRoomMemberMention.AsObject;
};

export type protoResponsesObjectType = {
  [methods.BILL_INQUIRY_MCI]: BillInquiryMciResponse.AsObject;
  [methods.BILL_INQUIRY_TELECOM]: BillInquiryTelecomResponse.AsObject;
  [methods.CHANNEL_ADD_ADMIN]: ChannelAddAdminResponse.AsObject;
  [methods.CHANNEL_ADD_MEMBER]: ChannelAddMemberResponse.AsObject;
  [methods.CHANNEL_ADD_MESSAGE_REACTION]: ChannelAddMessageReactionResponse.AsObject;
  [methods.CHANNEL_ADD_MODERATOR]: ChannelAddModeratorResponse.AsObject;
  [methods.CHANNEL_AVATAR_ADD]: ChannelAvatarAddResponse.AsObject;
  [methods.CHANNEL_AVATAR_DELETE]: ChannelAvatarDeleteResponse.AsObject;
  [methods.CHANNEL_AVATAR_GET_LIST]: ChannelAvatarGetListResponse.AsObject;
  [methods.CHANNEL_CHECK_USERNAME]: ChannelCheckUsernameResponse.AsObject;
  [methods.CHANNEL_CREATE]: ChannelCreateResponse.AsObject;
  [methods.CHANNEL_DELETE_MESSAGE]: ChannelDeleteMessageResponse.AsObject;
  [methods.CHANNEL_DELETE]: ChannelDeleteResponse.AsObject;
  [methods.CHANNEL_EDIT_MESSAGE]: ChannelEditMessageResponse.AsObject;
  [methods.CHANNEL_EDIT]: ChannelEditResponse.AsObject;
  [methods.CHANNEL_GET_DRAFT]: ChannelGetDraftResponse.AsObject;
  [methods.CHANNEL_GET_MEMBER_LIST]: ChannelGetMemberListResponse.AsObject;
  [methods.CHANNEL_GET_MESSAGES_STATS]: ChannelGetMessagesStatsResponse.AsObject;
  [methods.CHANNEL_KICK_ADMIN]: ChannelKickAdminResponse.AsObject;
  [methods.CHANNEL_KICK_MEMBER]: ChannelKickMemberResponse.AsObject;
  [methods.CHANNEL_KICK_MODERATOR]: ChannelKickModeratorResponse.AsObject;
  [methods.CHANNEL_LEFT]: ChannelLeftResponse.AsObject;
  [methods.CHANNEL_PIN_MESSAGE]: ChannelPinMessageResponse.AsObject;
  [methods.CHANNEL_REMOVE_USERNAME]: ChannelRemoveUsernameResponse.AsObject;
  [methods.CHANNEL_REVOKE_LINK]: ChannelRevokeLinkResponse.AsObject;
  [methods.CHANNEL_SEND_MESSAGE]: ChannelSendMessageResponse.AsObject;
  [methods.CHANNEL_UPDATE_DRAFT]: ChannelUpdateDraftResponse.AsObject;
  [methods.CHANNEL_UPDATE_REACTION_STATUS]: ChannelUpdateReactionStatusResponse.AsObject;
  [methods.CHANNEL_UPDATE_SIGNATURE]: ChannelUpdateSignatureResponse.AsObject;
  [methods.CHANNEL_UPDATE_USERNAME]: ChannelUpdateUsernameResponse.AsObject;
  [methods.CHAT_CLEAR_MESSAGE]: ChatClearMessageResponse.AsObject;
  [methods.CHAT_CONVERT_TO_GROUP]: ChatConvertToGroupResponse.AsObject;
  [methods.CHAT_DELETE_MESSAGE]: ChatDeleteMessageResponse.AsObject;
  [methods.CHAT_DELETE]: ChatDeleteResponse.AsObject;
  [methods.CHAT_EDIT_MESSAGE]: ChatEditMessageResponse.AsObject;
  [methods.CHAT_GET_DRAFT]: ChatGetDraftResponse.AsObject;
  [methods.CHAT_GET_ROOM]: ChatGetRoomResponse.AsObject;
  [methods.CHAT_SEND_MESSAGE]: ChatSendMessageResponse.AsObject;
  [methods.CHAT_SET_ACTION]: ChatSetActionResponse.AsObject;
  [methods.CHAT_UPDATE_DRAFT]: ChatUpdateDraftResponse.AsObject;
  [methods.CHAT_UPDATE_STATUS]: ChatUpdateStatusResponse.AsObject;
  [methods.CLIENT_CHECK_INVITE_LINK]: ClientCheckInviteLinkResponse.AsObject;
  [methods.CLIENT_CONDITION]: ClientConditionResponse.AsObject;
  [methods.CLIENT_COUNT_ROOM_HISTORY]: ClientCountRoomHistoryResponse.AsObject;
  [methods.CLIENT_GET_DISCOVERY]: ClientGetDiscoveryResponse.AsObject;
  [methods.CLIENT_GET_FAVORITE_MENU]: ClientGetFavoriteMenuResponse.AsObject;
  [methods.CLIENT_GET_POLL]: ClientGetPollResponse.AsObject;
  [methods.CLIENT_GET_PROMOTE]: ClientGetPromoteResponse.AsObject;
  [methods.CLIENT_GET_ROOM_HISTORY]: ClientGetRoomHistoryResponse.AsObject;
  [methods.CLIENT_GET_ROOM_LIST]: ClientGetRoomListResponse.AsObject;
  [methods.CLIENT_GET_ROOM_MESSAGE]: ClientGetRoomMessageResponse.AsObject;
  [methods.CLIENT_GET_ROOM]: ClientGetRoomResponse.AsObject;
  [methods.CLIENT_JOIN_BY_INVITE_LINK]: ClientJoinByInviteLinkResponse.AsObject;
  [methods.CLIENT_JOIN_BY_USERNAME]: ClientJoinByUsernameResponse.AsObject;
  [methods.CLIENT_MUTE_ROOM]: ClientMuteRoomResponse.AsObject;
  [methods.CLIENT_PIN_ROOM]: ClientPinRoomResponse.AsObject;
  [methods.CLIENT_REGISTER_DEVICE]: ClientRegisterDeviceResponse.AsObject;
  [methods.CLIENT_RESOLVE_USERNAME]: ClientResolveUsernameResponse.AsObject;
  [methods.CLIENT_ROOM_REPORT]: ClientRoomReportResponse.AsObject;
  [methods.CLIENT_SEARCH_ROOM_HISTORY]: ClientSearchRoomHistoryResponse.AsObject;
  [methods.CLIENT_SEARCH_USERNAME]: ClientSearchUsernameResponse.AsObject;
  [methods.CLIENT_SET_DISCOVERY_ITEM_AGREEMENT]: ClientSetDiscoveryItemAgreementResponse.AsObject;
  [methods.CLIENT_SET_DISCOVERY_ITEM_CLICK]: ClientSetDiscoveryItemClickResponse.AsObject;
  [methods.CLIENT_SET_POLL_ITEM_CLICK]: ClientSetPollItemClickResponse.AsObject;
  [methods.CLIENT_SUBSCRIBE_TO_ROOM]: ClientSubscribeToRoomResponse.AsObject;
  [methods.CLIENT_UNSUBSCRIBE_FROM_ROOM]: ClientUnsubscribeFromRoomResponse.AsObject;
  [methods.CONNECTION_SYMMETRIC_KEY]: ConnectionSymmetricKeyResponse.AsObject;
  [methods.FILE_DOWNLOAD]: FileDownloadResponse.AsObject;
  [methods.FILE_INFO]: FileInfoResponse.AsObject;
  [methods.FILE_UPLOAD_INIT]: FileUploadInitResponse.AsObject;
  [methods.FILE_UPLOAD_OPTION]: FileUploadOptionResponse.AsObject;
  [methods.FILE_UPLOAD]: FileUploadResponse.AsObject;
  [methods.FILE_UPLOAD_STATUS]: FileUploadStatusResponse.AsObject;
  [methods.GEO_GET_COMMENT]: GeoGetCommentResponse.AsObject;
  [methods.GEO_GET_CONFIGURATION]: GeoGetConfigurationResponse.AsObject;
  [methods.GEO_GET_NEARBY_COORDINATE]: GeoGetNearbyCoordinateResponse.AsObject;
  [methods.GEO_GET_NEARBY_DISTANCE]: GeoGetNearbyDistanceResponse.AsObject;
  [methods.GEO_GET_REGISTER_STATUS]: GeoGetRegisterStatusResponse.AsObject;
  [methods.GEO_REGISTER]: GeoRegisterResponse.AsObject;
  [methods.GEO_UPDATE_COMMENT]: GeoUpdateCommentResponse.AsObject;
  [methods.GEO_UPDATE_POSITION]: GeoUpdatePositionResponse.AsObject;
  [methods.GROUP_ADD_ADMIN]: GroupAddAdminResponse.AsObject;
  [methods.GROUP_ADD_MEMBER]: GroupAddMemberResponse.AsObject;
  [methods.GROUP_ADD_MODERATOR]: GroupAddModeratorResponse.AsObject;
  [methods.GROUP_AVATAR_ADD]: GroupAvatarAddResponse.AsObject;
  [methods.GROUP_AVATAR_DELETE]: GroupAvatarDeleteResponse.AsObject;
  [methods.GROUP_AVATAR_GET_LIST]: GroupAvatarGetListResponse.AsObject;
  [methods.GROUP_CHANGE_MEMBER_RIGHTS]: GroupChangeMemberRightsResponse.AsObject;
  [methods.GROUP_CHECK_USERNAME]: GroupCheckUsernameResponse.AsObject;
  [methods.GROUP_CLEAR_MESSAGE]: GroupClearMessageResponse.AsObject;
  [methods.GROUP_CREATE]: GroupCreateResponse.AsObject;
  [methods.GROUP_DELETE_MESSAGE]: GroupDeleteMessageResponse.AsObject;
  [methods.GROUP_DELETE]: GroupDeleteResponse.AsObject;
  [methods.GROUP_EDIT_MESSAGE]: GroupEditMessageResponse.AsObject;
  [methods.GROUP_EDIT]: GroupEditResponse.AsObject;
  [methods.GROUP_GET_DRAFT]: GroupGetDraftResponse.AsObject;
  [methods.GROUP_GET_MEMBER_LIST]: GroupGetMemberListResponse.AsObject;
  [methods.GROUP_KICK_ADMIN]: GroupKickAdminResponse.AsObject;
  [methods.GROUP_KICK_MEMBER]: GroupKickMemberResponse.AsObject;
  [methods.GROUP_KICK_MODERATOR]: GroupKickModeratorResponse.AsObject;
  [methods.GROUP_LEFT]: GroupLeftResponse.AsObject;
  [methods.GROUP_PIN_MESSAGE]: GroupPinMessageResponse.AsObject;
  [methods.GROUP_REMOVE_USERNAME]: GroupRemoveUsernameResponse.AsObject;
  [methods.GROUP_REVOKE_LINK]: GroupRevokeLinkResponse.AsObject;
  [methods.GROUP_SEND_MESSAGE]: GroupSendMessageResponse.AsObject;
  [methods.GROUP_SET_ACTION]: GroupSetActionResponse.AsObject;
  [methods.GROUP_UPDATE_DRAFT]: GroupUpdateDraftResponse.AsObject;
  [methods.GROUP_UPDATE_STATUS]: GroupUpdateStatusResponse.AsObject;
  [methods.GROUP_UPDATE_USERNAME]: GroupUpdateUsernameResponse.AsObject;
  [methods.HEARTBEAT]: HeartbeatResponse.AsObject;
  [methods.INFO_CONFIG]: InfoConfigResponse.AsObject;
  [methods.INFO_COUNTRY]: InfoCountryResponse.AsObject;
  [methods.INFO_LOCATION]: InfoLocationResponse.AsObject;
  [methods.INFO_PAGE]: InfoPageResponse.AsObject;
  [methods.INFO_TIME]: InfoTimeResponse.AsObject;
  [methods.INFO_WALLPAPER]: InfoWallpaperResponse.AsObject;
  [methods.INFO_UPDATE]: InfoUpdateResponse.AsObject;
  [methods.MPL_GET_BILL_TOKEN]: MplGetBillTokenResponse.AsObject;
  [methods.MPL_GET_SALES_TOKEN]: MplGetSalesTokenResponse.AsObject;
  [methods.MPL_GET_TOPUP_TOKEN]: MplGetTopupTokenResponse.AsObject;
  [methods.MPL_GET_TRANSACTION_LIST]: MplTransactionListResponse.AsObject;
  [methods.MPL_GET_TRANSACTION_INFO]: MplTransactionInfoResponse.AsObject;
  [methods.QR_CODE_ADD_CONTACT]: QrCodeAddContactResponse.AsObject;
  [methods.QR_CODE_ADD_ME]: QrCodeAddMeResponse.AsObject;
  [methods.QR_CODE_JOIN]: QrCodeJoinResponse.AsObject;
  [methods.QR_CODE_NEW_DEVICE]: QrCodeNewDeviceResponse.AsObject;
  [methods.QR_CODE_RESOLVE]: QrCodeResolveResponse.AsObject;
  [methods.SIGNALING_ACCEPT]: SignalingAcceptResponse.AsObject;
  [methods.SIGNALING_CANDIDATE]: SignalingCandidateResponse.AsObject;
  [methods.SIGNALING_CLEAR_LOG]: SignalingClearLogResponse.AsObject;
  [methods.SIGNALING_GET_CONFIGURATION]: SignalingGetConfigurationResponse.AsObject;
  [methods.SIGNALING_GET_LOG]: SignalingGetLogResponse.AsObject;
  [methods.SIGNALING_LEAVE]: SignalingLeaveResponse.AsObject;
  [methods.SIGNALING_OFFER]: SignalingOfferResponse.AsObject;
  [methods.SIGNALING_RATE]: SignalingRateResponse.AsObject;
  [methods.SIGNALING_RINGING]: SignalingRingingResponse.AsObject;
  [methods.SIGNALING_SESSION_HOLD]: SignalingSessionHoldResponse.AsObject;
  [methods.USER_AVATAR_ADD]: UserAvatarAddResponse.AsObject;
  [methods.USER_AVATAR_DELETE]: UserAvatarDeleteResponse.AsObject;
  [methods.USER_AVATAR_GET_LIST]: UserAvatarGetListResponse.AsObject;
  [methods.USER_CONTACTS_BLOCK]: UserContactsBlockResponse.AsObject;
  [methods.USER_CONTACTS_DELETE]: UserContactsDeleteResponse.AsObject;
  [methods.USER_CONTACTS_EDIT]: UserContactsEditResponse.AsObject;
  [methods.USER_CONTACTS_GET_BLOCKED_LIST]: UserContactsGetBlockedListResponse.AsObject;
  [methods.USER_CONTACTS_GET_LIST]: UserContactsGetListResponse.AsObject;
  [methods.USER_CONTACTS_IMPORT]: UserContactsImportResponse.AsObject;
  [methods.USER_CONTACTS_UNBLOCK]: UserContactsUnblockResponse.AsObject;
  [methods.USER_DELETE]: UserDeleteResponse.AsObject;
  [methods.USER_GET_DELETE_TOKEN]: UserGetDeleteTokenResponse.AsObject;
  [methods.USER_INFO]: UserInfoResponse.AsObject;
  [methods.USER_IVAND_GET_ACTIVITIES]: UserIVandGetActivitiesResponse.AsObject;
  [methods.USER_IVAND_GET_SCORE]: UserIVandGetScoreResponse.AsObject;
  [methods.USER_IVAND_SET_ACTIVITY]: UserIVandSetActivityResponse.AsObject;
  [methods.USER_LOGIN]: UserLoginResponse.AsObject;
  [methods.USER_PRIVACY_GET_RULE]: UserPrivacyGetRuleResponse.AsObject;
  [methods.USER_PRIVACY_SET_RULE]: UserPrivacySetRuleResponse.AsObject;
  [methods.USER_PROFILE_CHECK_USERNAME]: UserProfileCheckUsernameResponse.AsObject;
  [methods.USER_PROFILE_GET_BIO]: UserProfileGetBioResponse.AsObject;
  [methods.USER_PROFILE_GET_EMAIL]: UserProfileGetEmailResponse.AsObject;
  [methods.USER_PROFILE_GET_GENDER]: UserProfileGetGenderResponse.AsObject;
  [methods.USER_PROFILE_GET_NICKNAME]: UserProfileGetNicknameResponse.AsObject;
  [methods.USER_PROFILE_GET_REPRESENTATIVE]: UserProfileGetRepresentativeResponse.AsObject;
  [methods.USER_PROFILE_GET_SELF_REMOVE]: UserProfileGetSelfRemoveResponse.AsObject;
  [methods.USER_PROFILE_SET_BIO]: UserProfileSetBioResponse.AsObject;
  [methods.USER_PROFILE_SET_EMAIL]: UserProfileSetEmailResponse.AsObject;
  [methods.USER_PROFILE_SET_GENDER]: UserProfileSetGenderResponse.AsObject;
  [methods.USER_PROFILE_SET_NICKNAME]: UserProfileSetNicknameResponse.AsObject;
  [methods.USER_PROFILE_SET_REPRESENTATIVE]: UserProfileSetRepresentativeResponse.AsObject;
  [methods.USER_PROFILE_SET_SELF_REMOVE]: UserProfileSetSelfRemoveResponse.AsObject;
  [methods.USER_PROFILE_UPDATE_USERNAME]: UserProfileUpdateUsernameResponse.AsObject;
  [methods.USER_REGISTER]: UserRegisterResponse.AsObject;
  [methods.USER_REPORT]: UserReportResponse.AsObject;
  [methods.USER_SESSION_GET_ACTIVE_LIST]: UserSessionGetActiveListResponse.AsObject;
  [methods.USER_SESSION_LOGOUT]: UserSessionLogoutResponse.AsObject;
  [methods.USER_SESSION_TERMINATE]: UserSessionTerminateResponse.AsObject;
  [methods.USER_SET_BOT]: UserSetBotResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_HINT]: UserTwoStepVerificationChangeHintResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_EMAIL]: UserTwoStepVerificationChangeRecoveryEmailResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHANGE_RECOVERY_QUESTION]: UserTwoStepVerificationChangeRecoveryQuestionResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_CHECK_PASSWORD]: UserTwoStepVerificationCheckPasswordResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_GET_PASSWORD_DETAIL]: UserTwoStepVerificationGetPasswordDetailResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_ANSWERS]: UserTwoStepVerificationRecoverPasswordByAnswersResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RECOVER_PASSWORD_BY_TOKEN]: UserTwoStepVerificationRecoverPasswordByTokenResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_REQUEST_RECOVERY_TOKEN]: UserTwoStepVerificationRequestRecoveryTokenResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_RESEND_VERIFY_EMAIL]: UserTwoStepVerificationResendVerifyEmailResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_SET_PASSWORD]: UserTwoStepVerificationSetPasswordResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_UNSET_PASSWORD]: UserTwoStepVerificationUnsetPasswordResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_PASSWORD]: UserTwoStepVerificationVerifyPasswordResponse.AsObject;
  [methods.USER_TWO_STEP_VERIFICATION_VERIFY_RECOVERY_EMAIL]: UserTwoStepVerificationVerifyRecoveryEmailResponse.AsObject;
  [methods.USER_UPDATE_STATUS]: UserUpdateStatusResponse.AsObject;
  [methods.USER_USERNAME_TO_ID]: UserUsernameToIdResponse.AsObject;
  [methods.USER_VERIFY_NEW_DEVICE]: UserVerifyNewDeviceResponse.AsObject;
  [methods.USER_VERIFY]: UserVerifyResponse.AsObject;
  [methods.WALLET_GET_ACCESS_TOKEN]: WalletGetAccessTokenResponse.AsObject;
  [methods.WALLET_ID_MAPPING]: WalletIdMappingResponse.AsObject;
  [methods.WALLET_PAYMENT_INIT]: WalletPaymentInitResponse.AsObject;
  [methods.WALLET_REGISTER]: WalletRegisterResponse.AsObject;
  [methods.STORY_GET_STORIES]: StoryGetStoriesResponse.AsObject;
  [methods.STORY_ADD_STORIES]: StoryUserAddNewResponse.AsObject;
  [methods.STORY_ADD_VIEW]: StoryAddViewResponse.AsObject;
  [methods.STORY_GET_OWN_STORY_VIEWS]: StoryGetOwnStoryViewsResponse.AsObject;
  [methods.STORY_DELETE_STORY]: StoryDeleteStoryResponse.AsObject;
  [methods.CLIENT_ROOM_CHANGE_OWNER]: ClientRoomChangeOwnerResponse.AsObject;
  [methods.CLIENT_SEARCH]: ClientSearchResponse.AsObject;
  [methods.USER_CHANGE_PHONE_NUMBER]: ChangePhoneNumberResponse.AsObject;
  [methods.USER_VERIFY_NEW_PHONE_NUMBER]: VerifyNewPhoneNumberResponse.AsObject;
  [methods.GROUP_ROOM_MEMBER_MENTION]: GroupRoomMemberMentionResponse.AsObject;
  [methods.CLIENT_ROOM_MEMBER_SEARCH]: ClientRoomMemberSearchResponse.AsObject;
};
